
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("3eMTN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gdv5Z = parcelRequire("gdv5Z");

const $67004d95b34ee986$var$styles = {
    wrapper: "_c71lidpf _p12fidpf _kqswstnw"
};
const $67004d95b34ee986$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $42omo.useCallback)((e)=>{
        // Prevent click events from bubbling up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        role: "none",
        xcss: $67004d95b34ee986$var$styles.wrapper,
        onClick: onClick
    }, children);
};


const $a2cc1d898ee1f610$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a2cc1d898ee1f610$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($a2cc1d898ee1f610$var$FALLBACK_API);
const $a2cc1d898ee1f610$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $42omo.useState)(null);
    const api = (0, $42omo.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67004d95b34ee986$export$3e100bc08448f36c), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $42omo.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $42omo.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};
const $a2cc1d898ee1f610$export$1fd7f5f21a6d6cb8 = ()=>(0, $42omo.useContext)($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c);
module.exports["SmartLinkModalProvider"] = $a2cc1d898ee1f610$export$bb4eb02a83e1a0f8;
module.exports["useSmartLinkModal"] = $a2cc1d898ee1f610$export$1fd7f5f21a6d6cb8;

});

parcelRegister("4QzTV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $69abf735cbcf4e67$export$c3514c024fefef57 = ()=>{
    const context = (0, $eIleF.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $42omo.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};
module.exports["useSmartLinkRenderers"] = $69abf735cbcf4e67$export$c3514c024fefef57;

});

parcelRegister("k9nkv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $kCsup = parcelRequire("kCsup");


var $226XV = parcelRequire("226XV");


var $lz9QA = parcelRequire("lz9QA");


var $dz3R2 = parcelRequire("dz3R2");


var $l17Fn = parcelRequire("l17Fn");

const $04a4925b719a4690$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
const $04a4925b719a4690$var$NOT_ENABLED_RESULT = {
    isEnabled: false
};
/**
 * Returns whether the platform_sl_3p_auth_rovo_block_card_jira or platform_sl_3p_auth_rovo_block_card_confluence experiment
 * is enabled for the current user and link context.
 *
 * All eligibility criteria are consolidated here:
 * 1. Rovo chat must be enabled for the tenant.
 * 2. The consumer must have opted in via actionOptions.rovoChatAction.optIn.
 * 3. The link must support the RovoActions feature.
 * 4. The extension key must be one of the supported options.
 * 5. The experiment value must be true (via tmp-editor-statsig).
 *
 * The extension key is derived from the card store via the resolved URL,
 * so callers don't need to thread it as a prop.
 */ const $04a4925b719a4690$var$useBlockCardRovoActionExperiment = (url, actionOptions)=>{
    const { rovoOptions: rovoConfig, product: product } = (0, $l17Fn.default)();
    const isRovoChatEnabled = (0, $kCsup.getIsRovoChatEnabled)(rovoConfig);
    const cardState = (0, $lz9QA.useSmartCardState)(url ?? '');
    const extensionKey = (0, $226XV.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = actionOptions?.rovoChatAction?.optIn ?? false;
    return (0, $42omo.useMemo)(()=>{
        if (!isRovoChatEnabled || !url || !isRovoChatActionOptedIn) return $04a4925b719a4690$var$NOT_ENABLED_RESULT;
        if (extensionKey && !$04a4925b719a4690$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey)) return $04a4925b719a4690$var$NOT_ENABLED_RESULT;
        const isJiraEnabled = !!product && (0, $dz3R2.JIRA_PRODUCTS).includes(product) && (0, $dh538.fg)('platform_sl_3p_auth_rovo_block_jira_kill_switch') && (0, $1oCLl.expValEquals)('platform_sl_3p_auth_rovo_block_card_jira', 'isEnabled', true);
        const isConfluenceEnabled = !!product && product === 'CONFLUENCE' && (0, $dh538.fg)('platform_sl_3p_auth_rovo_block_card_kill_switch') && (0, $1oCLl.expValEquals)('platform_sl_3p_auth_rovo_block_card_confluence', 'isEnabled', true);
        return {
            isEnabled: isJiraEnabled || isConfluenceEnabled
        };
    }, [
        isRovoChatEnabled,
        extensionKey,
        url,
        isRovoChatActionOptedIn,
        product
    ]);
};
const $04a4925b719a4690$export$83698169feae8f9d = (product)=>{
    const isJiraEnabled = !!product && (0, $dz3R2.JIRA_PRODUCTS).includes(product) && (0, $dh538.fg)('platform_sl_3p_auth_rovo_block_jira_kill_switch') && (0, $dZ8uq.expValEqualsNoExposure)('platform_sl_3p_auth_rovo_block_card_jira', 'isEnabled', true);
    const isConfluenceEnabled = !!product && product === 'CONFLUENCE' && (0, $dh538.fg)('platform_sl_3p_auth_rovo_block_card_kill_switch') && (0, $dZ8uq.expValEqualsNoExposure)('platform_sl_3p_auth_rovo_block_card_confluence', 'isEnabled', true);
    return isJiraEnabled || isConfluenceEnabled;
};
const $04a4925b719a4690$export$177d6c4ac42795be = ()=>{
    const { product: product } = (0, $l17Fn.default)();
    return $04a4925b719a4690$export$83698169feae8f9d(product);
};
var $04a4925b719a4690$export$2e2bcd8739ae039 = $04a4925b719a4690$var$useBlockCardRovoActionExperiment;
module.exports["isBlockCardRovoActionExperimentEnabled"] = $04a4925b719a4690$export$83698169feae8f9d;
module.exports["useBlockCardRovoActionExperimentNoExposure"] = $04a4925b719a4690$export$177d6c4ac42795be;
module.exports["default"] = $04a4925b719a4690$export$2e2bcd8739ae039;

});

parcelRegister("kCsup", function(module, exports) {
const $c3643dd78ce3394f$export$e9a534e68169723d = (rovoConfig)=>rovoConfig?.isRovoEnabled && rovoConfig?.isRovoLLMEnabled ? true : false;
module.exports["getIsRovoChatEnabled"] = $c3643dd78ce3394f$export$e9a534e68169723d;

});

parcelRegister("l17Fn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $cc85c7b3ba72e34b$var$useRovoConfig = ()=>{
    const { rovoOptions: rovoOptions, product: product } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>({
            rovoOptions: rovoOptions,
            product: product
        }), [
        rovoOptions,
        product
    ]);
};
var $cc85c7b3ba72e34b$export$2e2bcd8739ae039 = $cc85c7b3ba72e34b$var$useRovoConfig;
module.exports["default"] = $cc85c7b3ba72e34b$export$2e2bcd8739ae039;

});

parcelRegister("kbh18", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");

const $681e47ebaeddecd0$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $681e47ebaeddecd0$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $afp1H.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5TXU5.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $afp1H.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $afp1H.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $dh538.fg)('platform_sl_ai_summary_rebrand') ? (0, $afp1H.messages).ai_summary_error_generic_rebrand : (0, $afp1H.messages).ai_summary_error_generic,
                url: (0, $5TXU5.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};
module.exports["getIsAISummaryEnabled"] = $681e47ebaeddecd0$export$d439c74cb206ff29;
module.exports["getAISummaryErrorMessage"] = $681e47ebaeddecd0$export$cd2e891d7f87074d;

});

parcelRegister("6KV13", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $99WQy = parcelRequire("99WQy");

var $l6lJr = parcelRequire("l6lJr");


var $kKODE = parcelRequire("kKODE");


var $bIll3 = parcelRequire("bIll3");


var $lz9QA = parcelRequire("lz9QA");





var $aXWIB = parcelRequire("aXWIB");

// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $dDhJe = parcelRequire("dDhJe");

const $80037b55255ba382$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $80037b55255ba382$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $80037b55255ba382$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $80037b55255ba382$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $80037b55255ba382$export$ff2962de2b2c930f = (product)=>{
    if ($80037b55255ba382$var$isJiraProduct(product)) return $80037b55255ba382$var$AiMateJiraXProduct[product];
    return product;
};


async function* $ac7ab9469e66450d$export$e45226161c660403(response) {
    const reader = (0, $80037b55255ba382$export$f6383c3ea1307da9)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}


class $518e18325393707f$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $518e18325393707f$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];



const $b962d377d695bb74$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $b962d377d695bb74$export$73e4b807d5bd74b6 {
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.content;
                if (chunk.type === 'ERROR') throw new (0, $518e18325393707f$export$fcec967a4b7ebd84)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $518e18325393707f$export$fcec967a4b7ebd84) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.config = void 0;
        this.url = void 0;
        this.ari = void 0;
        this.locale = void 0;
        this.subscribedStateSetters = new Set();
        this.onStart = void 0;
        this.onSuccess = void 0;
        this.onError = void 0;
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
                return (0, $80037b55255ba382$export$4c25481b843feb0b)(baseUrl, $b962d377d695bb74$var$CONVO_AI_ENDPOINT);
            }
            return (0, $80037b55255ba382$export$4c25481b843feb0b)('/gateway/api/', $b962d377d695bb74$var$CONVO_AI_ENDPOINT);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $ac7ab9469e66450d$export$e45226161c660403)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $80037b55255ba382$export$ff2962de2b2c930f)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
}



var $9trs7 = parcelRequire("9trs7");

const $ae7dbc37116e63f9$var$AI_SUMMARY_CACHE_SIZE = 100;
const $ae7dbc37116e63f9$export$6979339b6d41707e = new (0, $9trs7.LRUMap)($ae7dbc37116e63f9$var$AI_SUMMARY_CACHE_SIZE);


const $78ebc629fd62f804$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $42omo.useState)((0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)) (0, $ae7dbc37116e63f9$export$6979339b6d41707e).set(url, new (0, $b962d377d695bb74$export$73e4b807d5bd74b6)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};



var $i8IAc = parcelRequire("i8IAc");

const $c75904359bba5163$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $c75904359bba5163$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $i8IAc.useAISummaryConfig)();
    const cardState = (0, $lz9QA.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $99WQy.extractAri)(data);
    const dataUrl = data && (0, $l6lJr.extractLink)(data) || '';
    const onStart = (0, $42omo.useCallback)((id)=>{
        (0, $bIll3.startUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $42omo.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $bIll3.succeedUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $42omo.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $bIll3.failUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $78ebc629fd62f804$export$becd8f2eba1bbd96)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $c75904359bba5163$export$2e2bcd8739ae039 = $c75904359bba5163$var$useAISummaryAction;
module.exports["default"] = $c75904359bba5163$export$2e2bcd8739ae039;

});

parcelRegister("i8IAc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $524481383d1e73c2$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};
module.exports["useAISummaryConfig"] = $524481383d1e73c2$export$4480af2c00aa7ebe;

});

parcelRegister("fUfR2", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6e7308c6380408ec$export$13dde4423ab71d62 = (0, $42omo.createContext)(undefined);
const $6e7308c6380408ec$export$a8c4167e4e9f26ab = ()=>(0, $42omo.useContext)($6e7308c6380408ec$export$13dde4423ab71d62);
const $6e7308c6380408ec$export$61d7957a243df7aa = ()=>$6e7308c6380408ec$export$a8c4167e4e9f26ab()?.data;
const $6e7308c6380408ec$export$e6b5ad18b56e8f51 = ()=>$6e7308c6380408ec$export$a8c4167e4e9f26ab()?.ui;
module.exports["FlexibleCardContext"] = $6e7308c6380408ec$export$13dde4423ab71d62;
module.exports["useFlexibleCardContext"] = $6e7308c6380408ec$export$a8c4167e4e9f26ab;
module.exports["useFlexibleUiContext"] = $6e7308c6380408ec$export$61d7957a243df7aa;
module.exports["useFlexibleUiOptionContext"] = $6e7308c6380408ec$export$e6b5ad18b56e8f51;

});

parcelRegister("9E8aG", function(module, exports) {

var $42omo = parcelRequire("42omo");



var $2c99834a6fa1d6ad$exports = {};
$parcel$export($2c99834a6fa1d6ad$exports, "FooterBlock", () => (parcelRequire("8NpDA")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "MetadataBlock", () => (parcelRequire("1lLfV")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "PreviewBlock", () => (parcelRequire("Y5kOr")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "SnippetBlock", () => (parcelRequire("8zS2j")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "TitleBlock", () => (parcelRequire("5znEc")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "CustomBlock", () => (parcelRequire("2R1C4")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "InternalFooterBlock", () => (parcelRequire("jsdg1")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "AISummaryBlock", () => (parcelRequire("eqpYq")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "AIFooterBlock", () => (parcelRequire("MlN47")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "ResolvedHoverCardFooterBlock", () => (parcelRequire("7Twup")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "ActionBlock", () => (parcelRequire("f0wtW")).default);

var $8NpDA = parcelRequire("8NpDA");


var $1lLfV = parcelRequire("1lLfV");


var $Y5kOr = parcelRequire("Y5kOr");


var $8zS2j = parcelRequire("8zS2j");


var $5znEc = parcelRequire("5znEc");


var $2R1C4 = parcelRequire("2R1C4");


var $jsdg1 = parcelRequire("jsdg1");


var $eqpYq = parcelRequire("eqpYq");


var $MlN47 = parcelRequire("MlN47");


var $7Twup = parcelRequire("7Twup");


var $f0wtW = parcelRequire("f0wtW");




var $2gWqY = parcelRequire("2gWqY");

const $c224b37846f1c464$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).some((child)=>$c224b37846f1c464$export$df0092b19156b140(child))) return true;
    return false;
};
const $c224b37846f1c464$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $c224b37846f1c464$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($2c99834a6fa1d6ad$exports).some((type)=>type === node.type)) return true;
    return false;
};
const $c224b37846f1c464$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if (Object.values($2gWqY).some((type)=>type === node.type)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if (node.type === (0, $5znEc.default)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if (node.type === (0, $Y5kOr.default)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node) && node.type === (0, $8NpDA.default);
module.exports["isFlexibleUiCard"] = $c224b37846f1c464$export$3c94e0f4719f5c2a;
module.exports["isStyleCacheProvider"] = $c224b37846f1c464$export$14ff825bfe645006;
module.exports["isFlexibleUiBlock"] = $c224b37846f1c464$export$b56fc89cf6e7d1e9;
module.exports["isFlexibleUiElement"] = $c224b37846f1c464$export$d7fc505bb0bd5756;
module.exports["isFlexibleUiPreviewBlock"] = $c224b37846f1c464$export$c0547b4405cae584;

});

parcelRegister("8NpDA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $jsdg1 = parcelRequire("jsdg1");

/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $64d13bf310395f75$var$FooterBlock = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jsdg1.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $64d13bf310395f75$export$2e2bcd8739ae039 = $64d13bf310395f75$var$FooterBlock;
module.exports["default"] = $64d13bf310395f75$export$2e2bcd8739ae039;

});

parcelRegister("jsdg1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4P6U3 = parcelRequire("4P6U3");


var $4JDbp = parcelRequire("4JDbp");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $k9nkv = parcelRequire("k9nkv");


var $2ZgNz = parcelRequire("2ZgNz");


var $7d67T = parcelRequire("7d67T");


var $2R1C4 = parcelRequire("2R1C4");


var $1RvsP = parcelRequire("1RvsP");


var $l7DP7 = parcelRequire("l7DP7");

const $a5a88c936354623c$var$actionGroupStyles = null;
const $a5a88c936354623c$var$safariStyles = null;
const $a5a88c936354623c$var$providerStyles = null;
const $a5a88c936354623c$var$rovoActionStyles = null;
const $a5a88c936354623c$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5TXU5.SmartLinkSize).Medium, hideProvider: hideProvider, isPreviewBlockErrored: isPreviewBlockErrored } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const rovoChatAction = context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction];
    const is3PBlockExperimentEnabled = (0, $k9nkv.isBlockCardRovoActionExperimentEnabled)(rovoChatAction?.product);
    const hasPreview = !!rovoChatAction && is3PBlockExperimentEnabled && !!context?.preview && !isPreviewBlockErrored;
    const hasActions = (0, $42omo.useMemo)(()=>(0, $l7DP7.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $42omo.useMemo)(()=>(0, $4P6U3.browser)(), []);
    const onDropdownOpenChange = (0, $42omo.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]); // WidthObserver fires whenever the footer's available width changes.
    const [containerWidth, setContainerWidth] = (0, $42omo.useState)(undefined);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ $42omo.createElement((0, $2ZgNz.default), {
        appearance: "subtle",
        testId: `${testId}-provider`,
        hideLabel: hasPreview,
        className: (0, $gMc0m.default)([
            !!rovoChatAction && is3PBlockExperimentEnabled && "_1wpz1h6o"
        ])
    }), actions && hasActions ? /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        testId: "smart-element-group-actions",
        align: (0, $5TXU5.SmartLinkAlignment).Right,
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        className: (0, $gMc0m.default)([
            size === (0, $5TXU5.SmartLinkSize).XLarge && "_c71lxy5q",
            safari && "_4t3i1osq",
            !!rovoChatAction && is3PBlockExperimentEnabled && "_kqswh2mm"
        ])
    }, !!rovoChatAction && is3PBlockExperimentEnabled && /*#__PURE__*/ $42omo.createElement((0, $4JDbp.default), {
        setWidth: setContainerWidth,
        offscreen: true
    }), /*#__PURE__*/ $42omo.createElement((0, $7d67T.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: !!rovoChatAction && is3PBlockExperimentEnabled ? 'subtle' : 'default',
        size: !!rovoChatAction && is3PBlockExperimentEnabled ? (0, $5TXU5.SmartLinkSize).Small : size,
        containerWidth: !!rovoChatAction && is3PBlockExperimentEnabled ? containerWidth : undefined
    })) : null);
};
var $a5a88c936354623c$export$2e2bcd8739ae039 = $a5a88c936354623c$var$FooterBlockResolvedView;
module.exports["default"] = $a5a88c936354623c$export$2e2bcd8739ae039;

});

parcelRegister("2ZgNz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $33250de89c37863a$var$ProviderElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Provider
    }) : null;
};
var $33250de89c37863a$export$2e2bcd8739ae039 = $33250de89c37863a$var$ProviderElement;
module.exports["default"] = $33250de89c37863a$export$2e2bcd8739ae039;

});

parcelRegister("7d67T", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $hArLp = parcelRequire("hArLp");


var $eEA8O = parcelRequire("eEA8O");


var $52EPl = parcelRequire("52EPl");


var $9VJDA = parcelRequire("9VJDA");


var $3gadb = parcelRequire("3gadb");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $k9nkv = parcelRequire("k9nkv");


var $l17Fn = parcelRequire("l17Fn");


var $1MuZd = parcelRequire("1MuZd");


var $hJgLA = parcelRequire("hJgLA");


var $l7DP7 = parcelRequire("l7DP7");





var $jlQ9A = parcelRequire("jlQ9A");

const $98cfef5f1319cffc$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $42omo.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $98cfef5f1319cffc$export$2e2bcd8739ae039 = $98cfef5f1319cffc$var$ActionGroupItem;


const $56632f4bfc993cb1$var$styles = null;
const $56632f4bfc993cb1$var$FULL_ACTIONS_SIZE = 450;
const $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE = 360;
const $56632f4bfc993cb1$var$ICON_ONLY_ACTIONS_SIZE = 200;
const $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE = 100;
const $56632f4bfc993cb1$var$renderActionItems = (items = [], size = (0, $5TXU5.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ $42omo.createElement((0, $98cfef5f1319cffc$export$2e2bcd8739ae039), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        })); /**
                                                                                                                                                                                                                                                                                                                                                                                                            * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                                                                                                                                                                                                                                                                                                                                                                                                            * preferences.
                                                                                                                                                                                                                                                                                                                                                                                                            * @internal
                                                                                                                                                                                                                                                                                                                                                                                                            * @param {ActionGroupProps} ActionGroupProps
                                                                                                                                                                                                                                                                                                                                                                                                            * @see Action
                                                                                                                                                                                                                                                                                                                                                                                                            */ 
const $56632f4bfc993cb1$var$ActionGroup = ({ items: items = [], size: size = (0, $5TXU5.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange, containerWidth: containerWidth = Infinity })=>{
    (0, $fBMbo.di)((0, $52EPl.default));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const { product: product } = (0, $l17Fn.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const renderableActionItems = (0, $42omo.useMemo)(()=>(0, $l7DP7.filterActionItems)(items, context, product), [
        context,
        items,
        product
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const rovoChatAction = context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction];
    const is3PBlockExperimentEnabled = (0, $k9nkv.isBlockCardRovoActionExperimentEnabled)(rovoChatAction?.product);
    const onOpenChange = (0, $42omo.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $42omo.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $42omo.useMemo)(()=>{
        if (!!rovoChatAction && is3PBlockExperimentEnabled) {
            const rovoActions = [
                ...containerWidth >= $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE ? renderableActionItems.slice(0, visibleButtonsNum - 1) : [],
                ...containerWidth >= $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE ? [
                    {
                        name: (0, $5TXU5.ActionName).RovoChatAction,
                        prompts: [
                            (0, $1MuZd.RovoChatPromptKey).ASK_ROVO_ANYTHING
                        ],
                        iconSize: 'small',
                        cardAppearance: (0, $5TXU5.CardDisplay).Block,
                        hideContent: containerWidth < $56632f4bfc993cb1$var$FULL_ACTIONS_SIZE && containerWidth >= $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE || containerWidth < $56632f4bfc993cb1$var$ICON_ONLY_ACTIONS_SIZE && containerWidth >= $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE
                    },
                    {
                        name: (0, $5TXU5.ActionName).CopyLinkAction,
                        hideContent: true,
                        iconSize: 'small'
                    },
                    {
                        name: (0, $5TXU5.ActionName).PreviewAction,
                        hideContent: true,
                        iconSize: 'small'
                    }
                ] : []
            ];
            return $56632f4bfc993cb1$var$renderActionItems(rovoActions, size, appearance, false, onActionItemClick);
        }
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $56632f4bfc993cb1$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum,
        rovoChatAction,
        is3PBlockExperimentEnabled,
        containerWidth
    ]);
    const moreActionDropdown = (0, $42omo.useMemo)(()=>{
        let actionItems;
        if (!!rovoChatAction && is3PBlockExperimentEnabled && containerWidth < $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE) actionItems = [
            ...renderableActionItems,
            {
                name: (0, $5TXU5.ActionName).RovoChatAction,
                prompts: [
                    (0, $1MuZd.RovoChatPromptKey).ASK_ROVO_ANYTHING
                ],
                iconSize: 'small',
                cardAppearance: (0, $5TXU5.CardDisplay).Block
            },
            {
                name: (0, $5TXU5.ActionName).CopyLinkAction,
                iconSize: 'small'
            },
            {
                name: (0, $5TXU5.ActionName).PreviewAction,
                iconSize: 'small'
            }
        ];
        else if (!!rovoChatAction && is3PBlockExperimentEnabled && containerWidth < $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE) actionItems = renderableActionItems;
        else actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $hJgLA.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).more_actions);
            return /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
                        ...props,
                        spacing: !!rovoChatAction && is3PBlockExperimentEnabled ? size === (0, $5TXU5.SmartLinkSize).XLarge ? 'default' : 'compact' : spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef,
                        ...is3PBlockExperimentEnabled ? {
                            appearance: appearance
                        } : {}
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $56632f4bfc993cb1$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum,
        rovoChatAction,
        is3PBlockExperimentEnabled,
        containerWidth
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen
    }, /*#__PURE__*/ $42omo.createElement((0, $hArLp.default), null, actionButtons, moreActionDropdown)) : null;
};
var $56632f4bfc993cb1$export$2e2bcd8739ae039 = $56632f4bfc993cb1$var$ActionGroup;
module.exports["default"] = $56632f4bfc993cb1$export$2e2bcd8739ae039;

});

parcelRegister("1MuZd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4ymXE = parcelRequire("4ymXE");


var $lDwiy = parcelRequire("lDwiy");


var $a6IPc = parcelRequire("a6IPc");


var $cOQz3 = parcelRequire("cOQz3");


var $lAFHW = parcelRequire("lAFHW");


var $dZ8uq = parcelRequire("dZ8uq");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $k9nkv = parcelRequire("k9nkv");


var $9oOnT = parcelRequire("9oOnT");





var $dh538 = parcelRequire("dh538");


var $h982G = parcelRequire("h982G");


var $kCsup = parcelRequire("kCsup");


var $l17Fn = parcelRequire("l17Fn");


var $dz3R2 = parcelRequire("dz3R2");

const $5b3a995bb43373af$var$SMART_LINK_TO_ROVO_SOURCE = 'smart-link';
const $5b3a995bb43373af$var$useRovoChat = ()=>{
    const { rovoOptions: config, product: product } = (0, $l17Fn.default)();
    const { publishWithPostMessage: publishWithPostMessage } = (0, $h982G.useRovoPostMessageToPubsub)();
    const isRovoChatEnabled = (0, $kCsup.getIsRovoChatEnabled)(config);
    const isJiraProduct = product && (0, $dz3R2.JIRA_PRODUCTS).includes(product);
    const sendPromptMessage = (0, $42omo.useCallback)((data)=>{
        publishWithPostMessage({
            targetWindow: window.parent ?? window,
            payload: {
                type: 'chat-new',
                source: $5b3a995bb43373af$var$SMART_LINK_TO_ROVO_SOURCE,
                data: {
                    dialogues: [],
                    ...data,
                    agentId: undefined
                },
                openChat: true,
                openChatMode: isJiraProduct && ((0, $dh538.fg)('platform_sl_3p_auth_rovo_block_jira_kill_switch') || (0, $dh538.fg)('rovogrowth-640-inline-action-nudge-fg')) ? 'mini-modal' : 'sidebar'
            },
            onAcknowledgeTimeout: ()=>{
            // NAVX-3599: Add analytics event
            }
        });
    }, [
        publishWithPostMessage,
        isJiraProduct
    ]);
    return (0, $42omo.useMemo)(()=>({
            isRovoChatEnabled: isRovoChatEnabled,
            sendPromptMessage: sendPromptMessage
        }), [
        isRovoChatEnabled,
        sendPromptMessage
    ]);
};
var $5b3a995bb43373af$export$2e2bcd8739ae039 = $5b3a995bb43373af$var$useRovoChat;


/* ai-chapter-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");

const $d24cc54ef12e71e2$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $d24cc54ef12e71e2$var$AiChapterIcon = (props)=>/*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: "url(#paint0_angular_1804_15128_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "matrix(0.008 -0.00939228 0.0100184 0.0075 12 12.5)"
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "-1047.5",
        y: "-1047.5",
        width: "2095.01",
        height: "2095.01"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $d24cc54ef12e71e2$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":16.000001907348633,"m01":20.036861419677734,"m02":-6.0184345245361328,"m10":-18.784559249877930,"m11":15.000002861022949,"m12":14.392276763916016},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $42omo.createElement("defs", null, /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: "paint0_angular_1804_15128_clip_path"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z"
    }))));
$d24cc54ef12e71e2$var$AiChapterIcon.displayName = 'AiChapterIcon';
var $d24cc54ef12e71e2$export$2e2bcd8739ae039 = $d24cc54ef12e71e2$var$AiChapterIcon;


/* ai-edit-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $f48d50acd0691865$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $f48d50acd0691865$var$AiEditIcon = (props)=>/*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: "url(#paint0_angular_1804_16152_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "matrix(0.00799113 -0.0100185 0.0100073 0.00800004 11.9911 12)"
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "-1041.51",
        y: "-1041.51",
        width: "2083.02",
        height: "2083.02"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $f48d50acd0691865$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8358 9.85361C16.6169 9.07256 17.8832 9.07256 18.6642 9.85361L19.3965 10.5858C20.1775 11.3669 20.1775 12.6332 19.3965 13.4143L14.2594 18.5513C14.019 18.7917 13.7214 18.9668 13.3946 19.0602L10.2061 19.9712C9.94416 20.046 9.66229 19.973 9.46969 19.7804C9.27709 19.5878 9.20405 19.3059 9.27888 19.044L10.1899 15.8555C10.2833 15.5286 10.4584 15.231 10.6987 14.9907L15.8358 9.85361ZM17.6036 10.9143C17.4083 10.719 17.0917 10.719 16.8965 10.9143L16.3107 11.5001L17.75 12.9394L18.3358 12.3536C18.5311 12.1583 18.5311 11.8418 18.3358 11.6465L17.6036 10.9143ZM16.6894 14.0001L15.25 12.5607L11.7594 16.0513C11.6993 16.1114 11.6555 16.1858 11.6322 16.2675L11.092 18.158L12.9825 17.6179C13.0642 17.5946 13.1386 17.5508 13.1987 17.4907L16.6894 14.0001Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":15.982254981994629,"m01":20.014636993408203,"m02":-6.0073223114013672,"m10":-20.036954879760742,"m11":16.000076293945312,"m12":14.018474578857422},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: "url(#paint1_angular_1804_16152_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "matrix(0.00799113 -0.0100185 0.0100073 0.00800004 11.9911 12)"
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "-1041.51",
        y: "-1041.51",
        width: "2083.02",
        height: "2083.02"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $f48d50acd0691865$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.75 4C9.05931 4 9.3369 4.18989 9.449 4.47817L10.4494 7.0506L13.0218 8.051C13.3101 8.16311 13.5 8.44069 13.5 8.75C13.5 9.05931 13.3101 9.3369 13.0218 9.449L10.4494 10.4494L9.449 13.0218C9.3369 13.3101 9.05931 13.5 8.75 13.5C8.44069 13.5 8.16311 13.3101 8.051 13.0218L7.0506 10.4494L4.47817 9.449C4.18989 9.3369 4 9.05931 4 8.75C4 8.44069 4.18989 8.16311 4.47817 8.051L7.0506 7.0506L8.051 4.47817C8.16311 4.18989 8.44069 4 8.75 4ZM8.75 6.81927L8.329 7.90183C8.25279 8.09781 8.09781 8.25279 7.90183 8.329L6.81927 8.75L7.90183 9.171C8.09781 9.24721 8.25279 9.40219 8.329 9.59817L8.75 10.6807L9.171 9.59817C9.24721 9.40219 9.40219 9.24721 9.59817 9.171L10.6807 8.75L9.59817 8.329C9.40219 8.25279 9.24721 8.09781 9.171 7.90183L8.75 6.81927Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":15.982254981994629,"m01":20.014636993408203,"m02":-6.0073223114013672,"m10":-20.036954879760742,"m11":16.000076293945312,"m12":14.018474578857422},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $42omo.createElement("defs", null, /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: "paint0_angular_1804_16152_clip_path"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8358 9.85361C16.6169 9.07256 17.8832 9.07256 18.6642 9.85361L19.3965 10.5858C20.1775 11.3669 20.1775 12.6332 19.3965 13.4143L14.2594 18.5513C14.019 18.7917 13.7214 18.9668 13.3946 19.0602L10.2061 19.9712C9.94416 20.046 9.66229 19.973 9.46969 19.7804C9.27709 19.5878 9.20405 19.3059 9.27888 19.044L10.1899 15.8555C10.2833 15.5286 10.4584 15.231 10.6987 14.9907L15.8358 9.85361ZM17.6036 10.9143C17.4083 10.719 17.0917 10.719 16.8965 10.9143L16.3107 11.5001L17.75 12.9394L18.3358 12.3536C18.5311 12.1583 18.5311 11.8418 18.3358 11.6465L17.6036 10.9143ZM16.6894 14.0001L15.25 12.5607L11.7594 16.0513C11.6993 16.1114 11.6555 16.1858 11.6322 16.2675L11.092 18.158L12.9825 17.6179C13.0642 17.5946 13.1386 17.5508 13.1987 17.4907L16.6894 14.0001Z"
    })), /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: "paint1_angular_1804_16152_clip_path"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.75 4C9.05931 4 9.3369 4.18989 9.449 4.47817L10.4494 7.0506L13.0218 8.051C13.3101 8.16311 13.5 8.44069 13.5 8.75C13.5 9.05931 13.3101 9.3369 13.0218 9.449L10.4494 10.4494L9.449 13.0218C9.3369 13.3101 9.05931 13.5 8.75 13.5C8.44069 13.5 8.16311 13.3101 8.051 13.0218L7.0506 10.4494L4.47817 9.449C4.18989 9.3369 4 9.05931 4 8.75C4 8.44069 4.18989 8.16311 4.47817 8.051L7.0506 7.0506L8.051 4.47817C8.16311 4.18989 8.44069 4 8.75 4ZM8.75 6.81927L8.329 7.90183C8.25279 8.09781 8.09781 8.25279 7.90183 8.329L6.81927 8.75L7.90183 9.171C8.09781 9.24721 8.25279 9.40219 8.329 9.59817L8.75 10.6807L9.171 9.59817C9.24721 9.40219 9.40219 9.24721 9.59817 9.171L10.6807 8.75L9.59817 8.329C9.40219 8.25279 9.24721 8.09781 9.171 7.90183L8.75 6.81927Z"
    }))));
$f48d50acd0691865$var$AiEditIcon.displayName = 'AiEditIcon';
var $f48d50acd0691865$export$2e2bcd8739ae039 = $f48d50acd0691865$var$AiEditIcon;


/* ai-search-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $851aea84cbe6a73c$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $851aea84cbe6a73c$var$AiSearchIcon = (props)=>/*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: "url(#paint0_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $851aea84cbe6a73c$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $42omo.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: "url(#paint1_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $851aea84cbe6a73c$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $42omo.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $42omo.createElement("defs", null, /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: "paint0_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z"
    })), /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: "paint1_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z"
    }))));
$851aea84cbe6a73c$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $851aea84cbe6a73c$export$2e2bcd8739ae039 = $851aea84cbe6a73c$var$AiSearchIcon;



var $6FZ6a = parcelRequire("6FZ6a");

/**
 * This is a simplified version of html to adf conversion,
 * used specifically for SL RovoChatAction prompt message,
 * and does not support all ADF offered via @atlaskit/adf-utils
 *
 * Support: p, ul, li, text, b, strong, code, inlineCard (replace a hyperlink)
 */ 
var $bKVdz = parcelRequire("bKVdz");

var $iJQnc = parcelRequire("iJQnc");

var $caRYB = parcelRequire("caRYB");

var $5x0y1 = parcelRequire("5x0y1");

var $eyfm5 = parcelRequire("eyfm5");

var $2FFuS = parcelRequire("2FFuS");

var $aoDcQ = parcelRequire("aoDcQ");

var $36XMI = parcelRequire("36XMI");

const $e264bb7b4e675ff3$var$INLINE_TAG_NAMES = [
    'b',
    'strong',
    'code',
    'a',
    'inlineCard'
];
const $e264bb7b4e675ff3$var$BLOCK_TAG_NAMES = [
    'p',
    'ul',
    'ol',
    'li'
];
/**
 *   Group      Captures                Example
 *  ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *   match[1]   Self-closing tag name   br from <br/> or <img src="x"/>
 *   match[2]   Opening tag name        div from <div> or <div class="x">
 *   match[3]   Closing tag name        div from </div>
 *   match[4]   Text content            Hello world
 */ const $e264bb7b4e675ff3$var$htmlRegex = /<\s*(\w+)[^>]*?\s*\/\s*>|<\s*(\w+)[^>]*>|<\s*\/\s*(\w+)\s*>|([^<]+)/g;
const $e264bb7b4e675ff3$var$decodeHtmlEntities = (text = '')=>{
    return text.replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
};
const $e264bb7b4e675ff3$var$tokenizeHtml = (html)=>{
    const tokens = [];
    let match;
    while((match = $e264bb7b4e675ff3$var$htmlRegex.exec(html)) !== null){
        const selfClosingTag = match[1];
        const openingTag = match[2];
        const closingTag = match[3];
        const textContent = match[4];
        if (selfClosingTag) tokens.push({
            type: 'selfClosing',
            tagName: selfClosingTag.toLowerCase()
        });
        else if (openingTag) tokens.push({
            type: 'open',
            tagName: openingTag.toLowerCase()
        });
        else if (closingTag) tokens.push({
            type: 'close',
            tagName: closingTag.toLowerCase()
        });
        else if (textContent) {
            if (textContent?.trim()) tokens.push({
                type: 'text',
                content: $e264bb7b4e675ff3$var$decodeHtmlEntities(textContent)
            });
        }
    }
    return tokens;
};
const $e264bb7b4e675ff3$var$buildListItem = (content = [])=>{
    // Check if content has only text/inline elements
    const hasOnlyInlineContent = content.every((node)=>node.type === 'text' || node.type === 'hardBreak' || !node.type);
    if (hasOnlyInlineContent) // Wrap text content in a paragraph
    return (0, $eyfm5.listItem)([
        (0, $2FFuS.paragraph)(...content)
    ]);
    // Content has block elements (like nested lists), use as-is
    return (0, $eyfm5.listItem)(content);
};
const $e264bb7b4e675ff3$var$blockToAdf = (tagName, content = [])=>{
    switch(tagName){
        case 'p':
            return (0, $2FFuS.paragraph)(...content);
        case 'ul':
            return (0, $36XMI.bulletList)(...content);
        case 'li':
            return $e264bb7b4e675ff3$var$buildListItem(content);
    }
};
const $e264bb7b4e675ff3$var$inlineToAdf = (tagName, content)=>{
    switch(tagName){
        case 'b':
        case 'strong':
            return (0, $bKVdz.strong)(content);
        case 'code':
            return (0, $iJQnc.code)(content);
        case 'a':
        case 'inlineCard':
            return (0, $5x0y1.inlineCard)({
                url: content
            });
        default:
            return (0, $aoDcQ.text)(content);
    }
};
const $e264bb7b4e675ff3$var$parseTokensToAdf = (tokens)=>{
    const stack = [
        {
            type: 'root',
            content: []
        }
    ];
    let currentMarks = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const current = stack[stack.length - 1];
        switch(token.type){
            case 'text':
                if (token.content) {
                    const inlineAdfNode = $e264bb7b4e675ff3$var$inlineToAdf(currentMarks?.[0]?.type, token.content);
                    current.content.push(inlineAdfNode);
                }
                break;
            case 'open':
                if ($e264bb7b4e675ff3$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks.push({
                    type: token.tagName
                });
                else if ($e264bb7b4e675ff3$var$BLOCK_TAG_NAMES.includes(token.tagName)) stack.push({
                    type: token.tagName,
                    content: []
                });
                break;
            case 'close':
                // Inline formatting
                if (token.tagName && $e264bb7b4e675ff3$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks = currentMarks.filter((m)=>m.type !== token.tagName);
                else if (stack.length > 1) {
                    const closed = stack.pop();
                    const parent = stack[stack.length - 1];
                    const adfNode = $e264bb7b4e675ff3$var$blockToAdf(closed?.type, closed?.content);
                    if (adfNode) parent.content.push(adfNode);
                }
                break;
        }
    }
    // Return root content
    return stack[0].content;
};
/**
 * Convert HTML string to ADF format
 *
 * This is a simplified version specific for RovoChatAction prompt message
 * and does not support all ADF offered via @atlaskit/adf-utils
 */ const $e264bb7b4e675ff3$var$htmlToAdf = (html)=>{
    try {
        const tokens = $e264bb7b4e675ff3$var$tokenizeHtml(html);
        const adfContent = $e264bb7b4e675ff3$var$parseTokensToAdf(tokens);
        return (0, $caRYB.doc)(...adfContent);
    } catch  {
        return html;
    }
};
var $e264bb7b4e675ff3$export$2e2bcd8739ae039 = $e264bb7b4e675ff3$var$htmlToAdf;


var $cb943c3aeab7c86e$export$a9f8723a23072cb8 = /*#__PURE__*/ function(RovoChatPromptKey) {
    RovoChatPromptKey["RECOMMEND_OTHER_SOURCES"] = "recommend-other-sources";
    RovoChatPromptKey["SHOW_OTHER_MENTIONS"] = "show-other-mentions";
    RovoChatPromptKey["SUGGEST_IMPROVEMENT"] = "suggest-improvement";
    RovoChatPromptKey["SUMMARIZE_LINK"] = "summarize-link";
    RovoChatPromptKey["KEY_HIGHLIGHTS"] = "key-highlights";
    RovoChatPromptKey["ASK_ROVO_ANYTHING"] = "ask-rovo-anything";
    RovoChatPromptKey["IDENTIFY_KEY_POINTS"] = "identify-key-points";
    RovoChatPromptKey["IDENTIFY_KEY_TRENDS"] = "identify-key-trends";
    RovoChatPromptKey["FIND_OPEN_QUESTIONS"] = "find-open-questions";
    RovoChatPromptKey["HIGHLIGHT_RELEVANT_CONTENT"] = "highlight-relevant-content";
    RovoChatPromptKey["SUMMARIZE_THIS_FOR_ME"] = "summarize-this-for-me";
    RovoChatPromptKey["ASK_A_SPECIFIC_QUESTION"] = "ask-a-specific-question";
    RovoChatPromptKey["SHOW_ME_WHATS_RELEVANT"] = "show-me-whats-relevant";
    return RovoChatPromptKey;
}({});
const $cb943c3aeab7c86e$var$GOOGLE_PROMPTS = [
    "recommend-other-sources",
    "show-other-mentions",
    "suggest-improvement"
];
const $cb943c3aeab7c86e$var$GENERIC_3P_PROMPTS = [
    "show-me-whats-relevant",
    "summarize-this-for-me",
    "ask-a-specific-question"
];
const $cb943c3aeab7c86e$var$DEFAULT_PROMPTS = $cb943c3aeab7c86e$var$GOOGLE_PROMPTS;
const $cb943c3aeab7c86e$var$getContext = (intl, product)=>{
    switch(product){
        case 'CONFLUENCE':
            return {
                contextLong: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_confluence_page),
                contextShort: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_confluence_page_short)
            };
        case 'JSW':
        case 'JWM':
        case 'JSM':
        case 'JPD':
            return {
                contextLong: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_jira_work_item),
                contextShort: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_jira_work_item_short)
            };
    }
};
const $cb943c3aeab7c86e$var$getPromptAction = (promptKey, intl, url = '', product, iconSize, cardAppearance)=>{
    const { contextLong: contextLong, contextShort: contextShort } = $cb943c3aeab7c86e$var$getContext(intl, product) ?? {
        contextLong: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_generic),
        contextShort: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_generic)
    };
    const isBlockCard3PExperimentEnabled = (0, $k9nkv.isBlockCardRovoActionExperimentEnabled)(product);
    switch(promptKey){
        case "recommend-other-sources":
            const label_recommend = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_recommend_other_sources);
            const html_recommend = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_recommend_other_sources, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f48d50acd0691865$export$2e2bcd8739ae039), null),
                content: label_recommend,
                tooltipMessage: label_recommend,
                data: {
                    name: label_recommend,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_recommend)
                }
            };
        case "show-other-mentions":
            const label_other_mentions = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_show_other_mentions);
            const html_other_mentions = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_show_other_mentions, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d24cc54ef12e71e2$export$2e2bcd8739ae039), null),
                content: label_other_mentions,
                tooltipMessage: label_other_mentions,
                data: {
                    name: label_other_mentions,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_other_mentions)
                }
            };
        case "suggest-improvement":
            const label_improvement = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_suggest_improvement, {
                context: contextShort
            });
            const html_improvement = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_suggest_improvement, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $851aea84cbe6a73c$export$2e2bcd8739ae039), null),
                content: label_improvement,
                tooltipMessage: label_improvement,
                data: {
                    name: label_improvement,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_improvement)
                }
            };
        case "summarize-link":
            const label_summarize = intl.formatMessage((0, $afp1H.messages).ai_summarize);
            const html_summarize = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: cardAppearance === (0, $5TXU5.CardDisplay).Block && isBlockCard3PExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: label_summarize,
                    size: iconSize
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f48d50acd0691865$export$2e2bcd8739ae039), null),
                content: label_summarize,
                tooltipMessage: label_summarize,
                data: {
                    name: label_summarize,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_summarize),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "summarize-this-for-me":
            const label_summarize_this_for_me = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_summarize_this);
            const html_summarize_this_for_me = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                    label: label_summarize_this_for_me
                }),
                content: label_summarize_this_for_me,
                tooltipMessage: label_summarize_this_for_me,
                data: {
                    name: label_summarize_this_for_me,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_summarize_this_for_me),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "highlight-relevant-content":
            const label_highlight_relevant_content = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_highlight_relevant_content);
            const html_highlight_relevant_content = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d24cc54ef12e71e2$export$2e2bcd8739ae039), null),
                content: label_highlight_relevant_content,
                tooltipMessage: label_highlight_relevant_content,
                data: {
                    name: label_highlight_relevant_content,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_highlight_relevant_content),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "ask-rovo-anything":
            const label_ask_rovo_anything = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_ask_rovo_anything);
            const prompt_ask_rovo_anything = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: cardAppearance === (0, $5TXU5.CardDisplay).Block && isBlockCard3PExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                    label: label_ask_rovo_anything,
                    size: 'xxsmall',
                    shouldUseHexLogo: true
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $851aea84cbe6a73c$export$2e2bcd8739ae039), null),
                content: label_ask_rovo_anything,
                tooltipMessage: label_ask_rovo_anything,
                data: {
                    name: label_ask_rovo_anything,
                    dialogues: [],
                    prompt: prompt_ask_rovo_anything,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "ask-a-specific-question":
            const label_ask_a_specific_question = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_ask_a_specific_question);
            const prompt_ask_a_specific_question = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
                    label: label_ask_a_specific_question
                }),
                content: label_ask_a_specific_question,
                tooltipMessage: label_ask_a_specific_question,
                data: {
                    name: label_ask_a_specific_question,
                    dialogues: [],
                    prompt: prompt_ask_a_specific_question,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "key-highlights":
            const label_key_highlights = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_key_highlights);
            const html_key_highlights = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_key_highlights, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: label_key_highlights,
                    size: iconSize
                }),
                content: label_key_highlights,
                tooltipMessage: label_key_highlights,
                data: {
                    name: label_key_highlights,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_key_highlights)
                }
            };
        case "show-me-whats-relevant":
            const label_show_me_whats_relevant = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_show_me_whats_relevant);
            const html_show_me_whats_relevant = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymXE))), {
                    label: label_show_me_whats_relevant
                }),
                content: label_show_me_whats_relevant,
                tooltipMessage: label_show_me_whats_relevant,
                data: {
                    name: label_show_me_whats_relevant,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_show_me_whats_relevant)
                }
            };
        case "identify-key-trends":
            const label_identify_key_trends = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_identify_key_trends);
            const html_identify_key_trends = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_identify_key_trends, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: label_identify_key_trends,
                    size: iconSize
                }),
                content: label_identify_key_trends,
                tooltipMessage: label_identify_key_trends,
                data: {
                    name: label_identify_key_trends,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_identify_key_trends)
                }
            };
        case "identify-key-points":
            const label_identify_key_points = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_identify_key_points);
            const html_identify_key_points = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_identify_key_points, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: label_identify_key_points,
                    size: iconSize
                }),
                content: label_identify_key_points,
                tooltipMessage: label_identify_key_points,
                data: {
                    name: label_identify_key_points,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_identify_key_points)
                }
            };
        case "find-open-questions":
            const label_find_open_questions = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_find_open_questions);
            const html_find_open_questions = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_find_open_questions, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: label_find_open_questions,
                    size: iconSize
                }),
                content: label_find_open_questions,
                tooltipMessage: label_find_open_questions,
                data: {
                    name: label_find_open_questions,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_find_open_questions)
                }
            };
    }
};
const $cb943c3aeab7c86e$var$RovoChatAction = ({ onClick: onClickCallback, prompts: prompts, testId: testId = 'smart-action-rovo-chat-action', ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { isRovoChatEnabled: isRovoChatEnabled, sendPromptMessage: sendPromptMessage } = (0, $5b3a995bb43373af$export$2e2bcd8739ae039)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction];
    const resolvedPrompts = (0, $42omo.useMemo)(()=>{
        if (prompts) return prompts;
        if ((0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true)) return $cb943c3aeab7c86e$var$GENERIC_3P_PROMPTS;
        return $cb943c3aeab7c86e$var$DEFAULT_PROMPTS;
    }, [
        prompts
    ]);
    const invoke = (0, $9oOnT.default)({});
    const onClick = (0, $42omo.useCallback)((promptData, promptKey)=>{
        if (promptData && data?.invokeAction) {
            invoke({
                ...data?.invokeAction,
                actionFn: async ()=>sendPromptMessage(promptData),
                prompt: promptKey
            });
            onClickCallback?.();
        }
    }, [
        data?.invokeAction,
        invoke,
        onClickCallback,
        sendPromptMessage
    ]);
    const promptActions = (0, $42omo.useMemo)(()=>{
        return resolvedPrompts.map((promptKey, idx)=>{
            const { icon: icon, content: content, tooltipMessage: tooltipMessage, data: promptData } = $cb943c3aeab7c86e$var$getPromptAction(promptKey, intl, data?.url, data?.product, props.iconSize, props.cardAppearance) || {};
            return promptData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
                content: content,
                icon: icon,
                key: promptKey,
                onClick: ()=>onClick(promptData, promptKey),
                testId: `${testId}-${idx + 1}`,
                tooltipMessage: tooltipMessage,
                ...props
            }) : null;
        });
    }, [
        data,
        intl,
        onClick,
        resolvedPrompts,
        props,
        testId
    ]);
    return isRovoChatEnabled && data && promptActions?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, promptActions) : null;
};
var $cb943c3aeab7c86e$export$2e2bcd8739ae039 = $cb943c3aeab7c86e$var$RovoChatAction;
module.exports["RovoChatPromptKey"] = $cb943c3aeab7c86e$export$a9f8723a23072cb8;
module.exports["default"] = $cb943c3aeab7c86e$export$2e2bcd8739ae039;

});

parcelRegister("6FZ6a", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $1bHXt = parcelRequire("1bHXt");


var $9YwaJ = parcelRequire("9YwaJ");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");

var $7p4As = parcelRequire("7p4As");

var $dE1p6 = parcelRequire("dE1p6");


var $gdv5Z = parcelRequire("gdv5Z");


var $3gadb = parcelRequire("3gadb");





var $fUfR2 = parcelRequire("fUfR2");


var $k9nkv = parcelRequire("k9nkv");


var $1iDg7 = parcelRequire("1iDg7");


var $hJgLA = parcelRequire("hJgLA");

const $0c0e9865fe28e398$var$IconOnlyLarge = null;
const $0c0e9865fe28e398$var$SizeSmall = null;
const $0c0e9865fe28e398$var$styles = {
    textSmall: "_13bowadc _1q9t1wq8 _1rlg1g80 _bdn61h6o"
};
const $0c0e9865fe28e398$var$SizeSmallIconOnly = null;
const $0c0e9865fe28e398$var$SizeSmallNotIconOnly = null;
const $0c0e9865fe28e398$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $0c0e9865fe28e398$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $0c0e9865fe28e398$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $0c0e9865fe28e398$var$ActionButtonRefresh = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const isRovoBlockCardExperimentEnabled = (0, $k9nkv.useBlockCardRovoActionExperimentNoExposure)();
    const isRovoSupported = !!context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction] && isRovoBlockCardExperimentEnabled;
    const onButtonClick = (0, $42omo.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $42omo.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'default' : 'compact';
        const icon = iconBefore || iconAfter;
        const iconFn = icon ? ()=>icon : undefined;
        if (iconOnly && iconFn) {
            if (isLinkButton && iconFn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dE1p6.default), {
                appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $0c0e9865fe28e398$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $0c0e9865fe28e398$var$tooltipOptions
            });
        }
        const iconBeforeFn = iconBefore ? ()=>iconBefore : undefined;
        const iconAfterFn = iconAfter ? ()=>iconAfter : undefined;
        if (isLinkButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            href: href,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        xcss: (0, $1bHXt.cx)(isRovoSupported && size === (0, $5TXU5.SmartLinkSize).Small && $0c0e9865fe28e398$var$styles.textSmall)
    }, button);
});
const $0c0e9865fe28e398$var$ActionButtonRefreshWithOverrideCss = (0, $1iDg7.withOverrideCss)($0c0e9865fe28e398$var$ActionButtonRefresh);
const $0c0e9865fe28e398$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $42omo.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            size === (0, $5TXU5.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5TXU5.SmartLinkSize).Small && "_11c8wadc _k48p1wq8",
            size === (0, $5TXU5.SmartLinkSize).Small && iconOnly && "_1gflv77o _or3fv77o _1ddvv77o _1hhav77o _yhjmv77o _1trnv77o _1fstv77o _1xcev77o _1gqnv77o _1qdmv77o _df2rv77o _j1twv77o _11lvv77o _192bv77o _vbn7v77o _wfu3v77o",
            size === (0, $5TXU5.SmartLinkSize).Small && !iconOnly && "_11lv1b66 _192b1b66 _vbn71b66 _wfu31b66 _yhjm1b66 _1trn1b66 _1fst1b66 _1xce1b66",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $hJgLA.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
const $0c0e9865fe28e398$var$ActionButton = (props)=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c0e9865fe28e398$var$ActionButtonRefreshWithOverrideCss, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c0e9865fe28e398$var$ActionButtonNew, props);
};
var $0c0e9865fe28e398$export$2e2bcd8739ae039 = $0c0e9865fe28e398$var$ActionButton;






var $dAYOx = parcelRequire("dAYOx");


var $ivUmx = parcelRequire("ivUmx");

const $4e516599d84c6e93$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $ivUmx.handleOnClick)(onClick),
        testId: testId
    }, content);
var $4e516599d84c6e93$export$2e2bcd8739ae039 = $4e516599d84c6e93$var$ActionDropdownItem;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $cc9e773a3279151b$var$stackItemIconStylesCompiled = null;
const $cc9e773a3279151b$var$ActionIcon = ({ testId: testId, icon: icon })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $gMc0m.default)([
            "_1e0c116y"
        ])
    }, icon);
};
var $cc9e773a3279151b$export$2e2bcd8739ae039 = $cc9e773a3279151b$var$ActionIcon;






var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");










/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1Whri = parcelRequire("1Whri");







var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $9hlns = parcelRequire("9hlns");














const $cb337baea8f1bcdf$var$styles = {
    button: "_bfhksm61 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr31dpa _1di6fcek",
    pillButton: "_2rko1qi0 _189ee4h9 _1dqonqa1 _1h6d1l7x _kqswh2mm _bfhksm61 _u5f3u2gc _19bvv77o _1bsb1osq _1ah31i6y _irr31dpa _1di6fcek",
    content: "_11c8wadc _syazi7uo",
    pillContent: "_11c8wadc _syazi7uo _o5721q9c",
    spinner: "_1bsb1tcg _4t3i1tcg _1e0c116y _4cvr1h6o _1bah1h6o"
};
const $cb337baea8f1bcdf$var$pillIconWrapperStyles = null;
const $cb337baea8f1bcdf$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style, ariaLabel: ariaLabel })=>{
    const space = spaceOption ?? (0, $hJgLA.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const is3pExperimentEnabled = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') && (0, $dZ8uq.expValEqualsNoExposure)('platform_sl_3p_auth_rovo_action', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('rovogrowth-640-inline-action-nudge-fg') && (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true); /**
                                                                                                                                       * NOTE: We only apply the pill variant when there's text label
                                                                                                                                       * (textual `content`). Icon-only stack-item buttons (e.g. the link/expand
                                                                                                                                       * icons in the hover card footer) are also rendered with `as="stack-item"`
                                                                                                                                       * but pass `content=""` and should keep their original borderless styling.
                                                                                                                                       */ 
    const hasTextualContent = typeof content === 'string' ? content.trim().length > 0 : Boolean(content);
    const flexibleUiContext = (0, $fUfR2.useFlexibleUiContext)();
    const isInRovoActionStack = !!flexibleUiContext?.actions?.[(0, $5TXU5.ActionName).RovoChatAction];
    const isInlineActionNudgeExperiment = hasTextualContent && isInRovoActionStack && (0, $dh538.fg)('rovogrowth-640-inline-action-nudge-fg') && (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true);
    const icon = iconOption && isLoading ? /*#__PURE__*/ $42omo.createElement((0, $cc9e773a3279151b$export$2e2bcd8739ae039), {
        icon: is3pExperimentEnabled ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $cb337baea8f1bcdf$var$styles.spinner
        }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            size: 16,
            testId: `${testId}-loading`
        })) : /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            testId: `${testId}-loading`
        })
    }) : iconOption;
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)(isInlineActionNudgeExperiment ? $cb337baea8f1bcdf$var$styles.pillButton : $cb337baea8f1bcdf$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        style: style,
        ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) ? {
            'aria-label': ariaLabel
        } : {}
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        grow: isInlineActionNudgeExperiment ? 'hug' : 'fill',
        space: isInlineActionNudgeExperiment ? 'space.050' : space
    }, isInlineActionNudgeExperiment ? /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _1o9zidpf"
        ])
    }, icon) : icon, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(isInlineActionNudgeExperiment ? $cb337baea8f1bcdf$var$styles.pillContent : $cb337baea8f1bcdf$var$styles.content)
    }, content)));
};
var $cb337baea8f1bcdf$export$2e2bcd8739ae039 = $cb337baea8f1bcdf$var$ActionButton;


const $e828a55eaf50791b$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>{
    const flexibleUiContext = (0, $fUfR2.useFlexibleUiContext)();
    const isRovoAction = !!flexibleUiContext?.actions?.[(0, $5TXU5.ActionName).RovoChatAction];
    const isRovoPillVariant = isRovoAction && (0, $dh538.fg)('rovogrowth-640-inline-action-nudge-fg') && (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true);
    return hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb337baea8f1bcdf$export$2e2bcd8739ae039), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        position: isRovoPillVariant ? 'right' : undefined
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb337baea8f1bcdf$export$2e2bcd8739ae039), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
};
var $e828a55eaf50791b$export$2e2bcd8739ae039 = $e828a55eaf50791b$var$ActionStackItem;


/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1f726fde681f8fde$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc9e773a3279151b$export$2e2bcd8739ae039), {
        icon: icon,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e828a55eaf50791b$export$2e2bcd8739ae039), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip,
        ariaLabel: ariaLabel
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e516599d84c6e93$export$2e2bcd8739ae039), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c0e9865fe28e398$export$2e2bcd8739ae039), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, null, button) : button;
};
var $1f726fde681f8fde$export$2e2bcd8739ae039 = $1f726fde681f8fde$var$Action;
module.exports["default"] = $1f726fde681f8fde$export$2e2bcd8739ae039;

});

parcelRegister("bKVdz", function(module, exports) {

var $gKlAz = parcelRequire("gKlAz");

const $12b0f1868a399867$export$59ae2c325a998f89 = (maybeNode)=>(0, $gKlAz.applyMark)({
        type: 'strong'
    }, maybeNode);
module.exports["strong"] = $12b0f1868a399867$export$59ae2c325a998f89;

});

parcelRegister("36XMI", function(module, exports) {
const $1ea2bb3e2633a104$export$a140c94e5ea26bee = (...content)=>({
        type: 'bulletList',
        content: content
    });
module.exports["bulletList"] = $1ea2bb3e2633a104$export$a140c94e5ea26bee;

});

parcelRegister("l7DP7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $k9nkv = parcelRequire("k9nkv");


var $9E8aG = parcelRequire("9E8aG");


var $2gWqY = parcelRequire("2gWqY");


var $7d67T = parcelRequire("7d67T");


var $1RvsP = parcelRequire("1RvsP");

const $304e11160ef9ec7e$export$f942619ce67b1a41 = {
    [(0, $5TXU5.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Location]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Preview]: [
        'block'
    ],
    [(0, $5TXU5.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5TXU5.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).State]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Title]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).VoteCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).HostName]: [
        'inline'
    ]
};
const $304e11160ef9ec7e$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5TXU5.SmartLinkSize).Large:
            return 1;
        case (0, $5TXU5.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $304e11160ef9ec7e$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node) && node.type === (0, $7d67T.default);
const $304e11160ef9ec7e$var$isElementDisplayValid = (name, display)=>{
    return $304e11160ef9ec7e$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $304e11160ef9ec7e$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $304e11160ef9ec7e$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node) && ((0, $9E8aG.isFlexibleUiElement)(node) || node.type === (0, $1RvsP.default));
const $304e11160ef9ec7e$export$adbd04236f07a7d8 = (items = [], context, product)=>{
    const isBlockCard3PExperimentEnabled = (0, $k9nkv.isBlockCardRovoActionExperimentEnabled)(product);
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5TXU5.ActionName).DeleteAction:
            case (0, $5TXU5.ActionName).EditAction:
            case (0, $5TXU5.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5TXU5.ActionName)[item.name]);
            case (0, $5TXU5.ActionName).RovoChatAction:
                if (isBlockCard3PExperimentEnabled) return Boolean((0, $5TXU5.ActionName)[item.name]);
                // same as default case below
                // remove on cleanup of platform_sl_3p_auth_rovo_block_card_kill_switch
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $304e11160ef9ec7e$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child)=>{
        if ($304e11160ef9ec7e$var$isElementOrElementGroup(child) || $304e11160ef9ec7e$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $304e11160ef9ec7e$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $2gWqY[name];
        const typedProps = props;
        if (Element && $304e11160ef9ec7e$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!$304e11160ef9ec7e$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};
module.exports["filterActionItems"] = $304e11160ef9ec7e$export$adbd04236f07a7d8;
module.exports["renderChildren"] = $304e11160ef9ec7e$export$cd762ccf1a583d69;
module.exports["renderElementItems"] = $304e11160ef9ec7e$export$9678d3ca18bd7526;

});

parcelRegister("6cbph", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $05796b2533bfe14f$var$AssignedToElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AssignedTo
    }) : null;
};
var $05796b2533bfe14f$export$2e2bcd8739ae039 = $05796b2533bfe14f$var$AssignedToElement;
module.exports["default"] = $05796b2533bfe14f$export$2e2bcd8739ae039;

});

parcelRegister("aIzVM", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $hJgLA = parcelRequire("hJgLA");

const $1ecffae6e6a717dc$var$baseStyle = null;
const $1ecffae6e6a717dc$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $1ecffae6e6a717dc$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $hJgLA.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && $1ecffae6e6a717dc$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $7sObp.default)(maxLines)
        }
    }, formattedContent);
};
var $1ecffae6e6a717dc$export$2e2bcd8739ae039 = $1ecffae6e6a717dc$export$79422073c7118b5b;
const $1ecffae6e6a717dc$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};
const $1ecffae6e6a717dc$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
module.exports["default"] = $1ecffae6e6a717dc$export$2e2bcd8739ae039;
module.exports["toFormattedTextProps"] = $1ecffae6e6a717dc$export$b9738bf28fb14829;
module.exports["toTextProps"] = $1ecffae6e6a717dc$export$f12aecc78be3c7bb;

});

parcelRegister("4wLtQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $e65535d36ac745c6$var$AssignedToGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AssignedToGroup
    }) : null;
};
var $e65535d36ac745c6$export$2e2bcd8739ae039 = $e65535d36ac745c6$var$AssignedToGroupElement;
module.exports["default"] = $e65535d36ac745c6$export$2e2bcd8739ae039;

});

parcelRegister("iNImz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $68f91cb1c2b70cc7$var$AttachmentCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AttachmentCount
    }) : null;
};
var $68f91cb1c2b70cc7$export$2e2bcd8739ae039 = $68f91cb1c2b70cc7$var$AttachmentCountElement;
module.exports["default"] = $68f91cb1c2b70cc7$export$2e2bcd8739ae039;

});

parcelRegister("LrBxG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $5665fdfe0a3a6612$var$AuthorGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AuthorGroup
    }) : null;
};
var $5665fdfe0a3a6612$export$2e2bcd8739ae039 = $5665fdfe0a3a6612$var$AuthorGroupElement;
module.exports["default"] = $5665fdfe0a3a6612$export$2e2bcd8739ae039;

});

parcelRegister("bWsCB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $9683283e28315c04$var$ChecklistProgressElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ChecklistProgress
    }) : null;
};
var $9683283e28315c04$export$2e2bcd8739ae039 = $9683283e28315c04$var$ChecklistProgressElement;
module.exports["default"] = $9683283e28315c04$export$2e2bcd8739ae039;

});

parcelRegister("azCqP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $853fada055614992$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CollaboratorGroup
    }) : null;
};
var $853fada055614992$export$2e2bcd8739ae039 = $853fada055614992$var$CollaboratorGroupElement;
module.exports["default"] = $853fada055614992$export$2e2bcd8739ae039;

});

parcelRegister("kexiH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $0c173ce05ce57544$var$CommentCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).CommentCount
    }) : null;
};
var $0c173ce05ce57544$export$2e2bcd8739ae039 = $0c173ce05ce57544$var$CommentCountElement;
module.exports["default"] = $0c173ce05ce57544$export$2e2bcd8739ae039;

});

parcelRegister("e8W8a", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $6wR2f = parcelRequire("6wR2f");

const $047203c23d0cd021$var$CreatedOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CreatedOn
    }) : null;
};
var $047203c23d0cd021$export$2e2bcd8739ae039 = $047203c23d0cd021$var$CreatedOnElement;
module.exports["default"] = $047203c23d0cd021$export$2e2bcd8739ae039;

});

parcelRegister("3nul2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $916e74797092cad1$var$CreatedByElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CreatedBy
    }) : null;
};
var $916e74797092cad1$export$2e2bcd8739ae039 = $916e74797092cad1$var$CreatedByElement;
module.exports["default"] = $916e74797092cad1$export$2e2bcd8739ae039;

});

parcelRegister("jKoRo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $7f92O = parcelRequire("7f92O");

const $d5c24538631868a6$var$DueOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $7f92O.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f92O.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).DueOn,
        isDateTag: true
    }) : null;
};
var $d5c24538631868a6$export$2e2bcd8739ae039 = $d5c24538631868a6$var$DueOnElement;
module.exports["default"] = $d5c24538631868a6$export$2e2bcd8739ae039;

});

parcelRegister("4X6f2", function(module, exports) {
/**
 * The enum that describes Smart Link action types
 */ var $c5c90dd6b941df7e$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $c5c90dd6b941df7e$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = void 0;
        this.errorCode = errorCode;
    }
}
module.exports["SmartLinkActionType"] = $c5c90dd6b941df7e$export$6324b7946ad663e9;
module.exports["InvokeError"] = $c5c90dd6b941df7e$export$d4d72202bff63658;

});

parcelRegister("bmx11", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $c95f1e4b0b62823d$var$LatestCommitElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).LatestCommit
    }) : null;
};
var $c95f1e4b0b62823d$export$2e2bcd8739ae039 = $c95f1e4b0b62823d$var$LatestCommitElement;
module.exports["default"] = $c95f1e4b0b62823d$export$2e2bcd8739ae039;

});

parcelRegister("jI5eg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $4NlKF = parcelRequire("4NlKF");

const $99638138120cbe3d$var$excludedResourceTypes = [
    '0',
    'unknown',
    'unsupported',
    'REDACTED'
];
const $99638138120cbe3d$var$manualMapping = {
    jswBoard: 'Jira Software Board',
    calendarJsw: 'Jira Software Calendar',
    kbArticle: 'Knowledge Base Article',
    pull: 'Pull Request',
    repo: 'Repository'
};
/**
 * Splits a resolver `resourceType` token into human-oriented words.
 * Prefers kebab-case (`-`) when present; otherwise splits camelCase / PascalCase.
 */ function $99638138120cbe3d$var$splitIntoWords(resourceType) {
    if (resourceType.includes('-')) return resourceType.split('-').map((w)=>w.trim()).filter(Boolean);
    const spaced = resourceType.replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
    return spaced.split(/\s+/).filter(Boolean);
}
function $99638138120cbe3d$var$titleCaseWord(word) {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
function $99638138120cbe3d$export$3422b5d26145468d(resourceType) {
    const trimmed = resourceType?.trim();
    if (!trimmed) return undefined;
    if ($99638138120cbe3d$var$excludedResourceTypes.includes(trimmed)) return undefined;
    const manual = $99638138120cbe3d$var$manualMapping[trimmed];
    if (manual !== undefined) return manual;
    const words = $99638138120cbe3d$var$splitIntoWords(trimmed);
    if (words.length === 0) return undefined;
    return words.map($99638138120cbe3d$var$titleCaseWord).join(' ');
} // Following are unique resourceType values for the past week (at the the time of writing) for reference:
 // page
 // issue
 // 0
 // (none)
 // unknown
 // file
 // space
 // message
 // jswBoard
 // video
 // card
 // project
 // board
 // repository
 // whiteboard
 // channel
 // pull-request
 // mergeRequest
 // database
 // pullRequest
 // singlePortalPage
 // folder
 // dashboard
 // requestCreateForm
 // commit
 // jql
 // blog
 // version
 // backlog
 // undefinedLink
 // branch
 // report
 // planTimeline
 // sharepointFile
 // comment
 // roadmap
 // idea
 // case
 // opportunity
 // account
 // list
 // issues
 // view
 // workItem
 // link
 // block
 // kbArticle
 // form
 // summary
 // task
 // search
 // visitor
 // public-link
 // user
 // playlist
 // prototype
 // deal
 // screen
 // pipeline
 // contact
 // incident
 // sheet
 // featureFlag
 // release
 // switcheroo-flag
 // single-calendar
 // repo
 // formBuilder
 // proformaForm
 // object
 // tiny
 // document
 // sharedFile
 // campaign
 // table
 // compassComponent
 // timeline
 // boardInvite
 // action
 // embed
 // objectType
 // calendar
 // calendarJsw
 // publishedView
 // template
 // gist
 // recording
 // plan
 // planDependencies
 // epic
 // oneDriveFile
 // chart
 // capability
 // artboard
 // planCalendar
 // planSummary
 // projectTeamTag
 // planProgram
 // compassComponentSearchQuery
 // feature
 // workspace
 // company
 // insight
 // customer
 // Page
 // schema
 // dependency
 // note
 // article
 // snippet
 // tag
 // goal
 // security
 // collaborationGroup
 // envelope
 // code
 // boardView
 // compassScorecard
 // invoice
 // theme
 // customWorkspaceView
 // risk
 // reel
 // deployments
 // objective
 // ask
 // compassMetricDefinition
 // compassComponentAnnouncement
 // portals
 // asks
 // breadcrumbChart
 // Chart
 // slide
 // unsupported
 // remote-link
 // pull
 // REDACTED
 // compassComponentScorecard
 // forms
 // sante
 // zoom


const $b061eed85b2a3300$var$LinkIconElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (!context) return null;
    if ((0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const linkIconProps = (0, $4NlKF.toLinkIconProps)(context?.linkIcon, context.type);
        if (!linkIconProps) return null;
        const label = (0, $99638138120cbe3d$export$3422b5d26145468d)(context.meta?.resourceType) ?? linkIconProps.label?.trim() ?? props.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NlKF.default), {
            ...linkIconProps,
            ...props,
            label: label,
            name: (0, $5TXU5.ElementName).LinkIcon
        });
    }
    const data = (0, $4NlKF.toLinkIconProps)(context?.linkIcon, context.type);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NlKF.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).LinkIcon
    }) : null;
};
var $b061eed85b2a3300$export$2e2bcd8739ae039 = $b061eed85b2a3300$var$LinkIconElement;
module.exports["default"] = $b061eed85b2a3300$export$2e2bcd8739ae039;

});

parcelRegister("4NlKF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bY7o = parcelRequire("1bY7o");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $i7jPX = parcelRequire("i7jPX");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");


var $b6b6P = parcelRequire("b6b6P");


var $iFRRf = parcelRequire("iFRRf");


var $hJgLA = parcelRequire("hJgLA");

const $5f41eba93c8538ef$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $5f41eba93c8538ef$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $5f41eba93c8538ef$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym"
};
const $5f41eba93c8538ef$var$renderAtlaskitIcon = (icon, testId, size = (0, $5TXU5.SmartLinkSize).Medium, label, isTiledIcon)=>{
    if (icon) return /*#__PURE__*/ $42omo.createElement((0, $iFRRf.default), {
        icon: icon,
        testId: `${testId}-icon`,
        ...(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            label: label
        } : {
            'aria-hidden': true,
            label: ''
        },
        size: size,
        isTiledIcon: isTiledIcon
    });
};
const $5f41eba93c8538ef$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $5f41eba93c8538ef$var$widthFromSize = (size, isTiledIcon)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return isTiledIcon ? "var(--ds-space-250, 20px)" : "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Small:
            return "var(--ds-space-200, 16px)";
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $5f41eba93c8538ef$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5TXU5.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label)=>{
    const width = size === (0, $5TXU5.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ $42omo.createElement((0, $b6b6P.default), {
        ...(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            label: label
        } : {},
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $5f41eba93c8538ef$var$renderImageIconNew = (defaultIcon, url, testId, size = (0, $5TXU5.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label, isTiledIcon = false)=>{
    const width = $5f41eba93c8538ef$var$widthFromSize(size, isTiledIcon);
    if (url) return /*#__PURE__*/ $42omo.createElement((0, $b6b6P.default), {
        ...(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            label: label
        } : {},
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
}; /**
    * A base element that displays an Icon or favicon.
    * @internal
    * @param props - The props necessary for the Icon element.
    * @see LinkIcon
    */ 
const $5f41eba93c8538ef$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: labelProp, name: name, position: position = (0, $5TXU5.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton, isTiledIcon: isTiledIcon })=>{
    const label = (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? labelProp ?? '' : labelProp ?? 'Link';
    const element = (0, $42omo.useMemo)(()=>{
        const defaultIcon = $5f41eba93c8538ef$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || ((0, $dh538.fg)('platform_sl_3p_preauth_better_hovercard_killswitch') ? $5f41eba93c8538ef$var$renderImageIconNew(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? label : undefined, isTiledIcon) : $5f41eba93c8538ef$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? label : undefined)) || $5f41eba93c8538ef$var$renderAtlaskitIcon(icon, testId, size, (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? label : undefined, isTiledIcon) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon,
        isTiledIcon
    ]);
    const width = (0, $hJgLA.getIconWidth)(size);
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $5f41eba93c8538ef$var$styles.container,
            $5f41eba93c8538ef$var$positionStyleMap[position],
            render && $5f41eba93c8538ef$var$customRenderStyleMap[size],
            className
        ])
    }, isTiledIcon ? /*#__PURE__*/ $42omo.createElement((0, $i7jPX.default), {
        size: size,
        hasBorder: true,
        backgroundColor: "white",
        label: label,
        testId: `${testId}-tile`
    }, element) : /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $5f41eba93c8538ef$var$styles.iconWrapperStyle,
        testId: `${testId}-box`,
        style: {
            width: width,
            height: width
        }
    }, element));
};
var $5f41eba93c8538ef$export$2e2bcd8739ae039 = $5f41eba93c8538ef$var$IconElement;
const $5f41eba93c8538ef$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $ivUmx.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};
module.exports["default"] = $5f41eba93c8538ef$export$2e2bcd8739ae039;
module.exports["toLinkIconProps"] = $5f41eba93c8538ef$export$6d33abd591a3f700;

});

parcelRegister("8iOdP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $8bb8e = parcelRequire("8bb8e");

const $7078b0bbce341226$var$LocationElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bb8e.default), {
        theme: (0, $5TXU5.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Location
    }) : null;
};
var $7078b0bbce341226$export$2e2bcd8739ae039 = $7078b0bbce341226$var$LocationElement;
module.exports["default"] = $7078b0bbce341226$export$2e2bcd8739ae039;

});

parcelRegister("jW9GW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $7578031676e72aae$var$ModifiedByElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ModifiedBy
    }) : null;
};
var $7578031676e72aae$export$2e2bcd8739ae039 = $7578031676e72aae$var$ModifiedByElement;
module.exports["default"] = $7578031676e72aae$export$2e2bcd8739ae039;

});

parcelRegister("1WqHG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $6wR2f = parcelRequire("6wR2f");

const $eaad8a74af19aa38$var$ModifiedOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).ModifiedOn
    }) : null;
};
var $eaad8a74af19aa38$export$2e2bcd8739ae039 = $eaad8a74af19aa38$var$ModifiedOnElement;
module.exports["default"] = $eaad8a74af19aa38$export$2e2bcd8739ae039;

});

parcelRegister("ful5o", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $42f47b467fa462a3$var$OwnedByElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages)[textPrefix], context?.ownedBy) : null;
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).OwnedBy
    }) : null;
};
var $42f47b467fa462a3$export$2e2bcd8739ae039 = $42f47b467fa462a3$var$OwnedByElement;
module.exports["default"] = $42f47b467fa462a3$export$2e2bcd8739ae039;

});

parcelRegister("41AV3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $085ad7f5d3b72529$var$OwnedByGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).OwnedByGroup
    }) : null;
};
var $085ad7f5d3b72529$export$2e2bcd8739ae039 = $085ad7f5d3b72529$var$OwnedByGroupElement;
module.exports["default"] = $085ad7f5d3b72529$export$2e2bcd8739ae039;

});

parcelRegister("ikM9T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $b6b6P = parcelRequire("b6b6P");

const $531c533c77a52797$var$styles = null;
const $531c533c77a52797$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (!type || !url) return null;
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $b6b6P.default), {
        hideLoadingSkeleton: ui?.hideLoadingSkeleton,
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $531c533c77a52797$export$2e2bcd8739ae039 = $531c533c77a52797$var$MediaElement;


const $a98281f2c459b443$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5TXU5.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531c533c77a52797$export$2e2bcd8739ae039), {
        ...rest,
        ...data
    });
};
var $a98281f2c459b443$export$2e2bcd8739ae039 = $a98281f2c459b443$var$PreviewElement;
module.exports["default"] = $a98281f2c459b443$export$2e2bcd8739ae039;

});

parcelRegister("8YJtM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $ecf289c1a2ef6a7c$var$PriorityElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Priority
    }) : null;
};
var $ecf289c1a2ef6a7c$export$2e2bcd8739ae039 = $ecf289c1a2ef6a7c$var$PriorityElement;
module.exports["default"] = $ecf289c1a2ef6a7c$export$2e2bcd8739ae039;

});

parcelRegister("6Ed8U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $3c7f8fc790c1b094$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ProgrammingLanguage
    }) : null;
};
var $3c7f8fc790c1b094$export$2e2bcd8739ae039 = $3c7f8fc790c1b094$var$ProgrammingLanguageElement;
module.exports["default"] = $3c7f8fc790c1b094$export$2e2bcd8739ae039;

});

parcelRegister("iuEuh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $5efcddd7e05f410f$var$ReactCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).React,
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).ReactCount
    }) : null;
};
var $5efcddd7e05f410f$export$2e2bcd8739ae039 = $5efcddd7e05f410f$var$ReactCountElement;
module.exports["default"] = $5efcddd7e05f410f$export$2e2bcd8739ae039;

});

parcelRegister("2GDee", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $2b374eebbbeae9d3$var$ReadTimeElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ReadTime
    }) : null;
};
var $2b374eebbbeae9d3$export$2e2bcd8739ae039 = $2b374eebbbeae9d3$var$ReadTimeElement;
module.exports["default"] = $2b374eebbbeae9d3$export$2e2bcd8739ae039;

});

parcelRegister("h2WFd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $6wR2f = parcelRequire("6wR2f");

const $b4843e0ca575cd89$var$SentOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SentOn
    }) : null;
};
var $b4843e0ca575cd89$export$2e2bcd8739ae039 = $b4843e0ca575cd89$var$SentOnElement;
module.exports["default"] = $b4843e0ca575cd89$export$2e2bcd8739ae039;

});

parcelRegister("49WiA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $4a2a6a0afaba68de$var$snippetBaseStyle = null;
const $4a2a6a0afaba68de$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $fUfR2.useFlexibleUiContext)();
    return /*#__PURE__*/ $42omo.createElement((0, $aIzVM.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        className: (0, $gMc0m.default)([
            "_syazi7uo _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $4a2a6a0afaba68de$export$2e2bcd8739ae039 = $4a2a6a0afaba68de$var$SnippetElement;
module.exports["default"] = $4a2a6a0afaba68de$export$2e2bcd8739ae039;

});

parcelRegister("aGsNO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $2b9dc14522cad497$var$SourceBranchElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SourceBranch
    }) : null;
};
var $2b9dc14522cad497$export$2e2bcd8739ae039 = $2b9dc14522cad497$var$SourceBranchElement;
module.exports["default"] = $2b9dc14522cad497$export$2e2bcd8739ae039;

});

parcelRegister("emfmd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $7f92O = parcelRequire("7f92O");

const $ba597065b544e1bf$var$STATE_METRIC_REGEX = /^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/;
const $ba597065b544e1bf$var$StateElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.state ?? null;
    const metricProps = (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useMemo)(()=>{
        if (data && typeof data.text === 'string') {
            const match = data.text.match($ba597065b544e1bf$var$STATE_METRIC_REGEX);
            if (match) return {
                text: match[1],
                trailingMetric: match[2]
            };
        }
        return null;
    }, [
        data
    ]) : undefined;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f92O.default), {
        ...data,
        ...props,
        ...metricProps,
        name: (0, $5TXU5.ElementName).State
    });
};
var $ba597065b544e1bf$export$2e2bcd8739ae039 = $ba597065b544e1bf$var$StateElement;
module.exports["default"] = $ba597065b544e1bf$export$2e2bcd8739ae039;

});

parcelRegister("a0Yyn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $9a2e44abfd20874f$var$SubscriberCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SubscriberCount
    }) : null;
};
var $9a2e44abfd20874f$export$2e2bcd8739ae039 = $9a2e44abfd20874f$var$SubscriberCountElement;
module.exports["default"] = $9a2e44abfd20874f$export$2e2bcd8739ae039;

});

parcelRegister("b8mrt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $a84eddedac7cbcb2$var$SubTasksProgressElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SubTasksProgress
    }) : null;
};
var $a84eddedac7cbcb2$export$2e2bcd8739ae039 = $a84eddedac7cbcb2$var$SubTasksProgressElement;
module.exports["default"] = $a84eddedac7cbcb2$export$2e2bcd8739ae039;

});

parcelRegister("jpKes", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $c4sKh = parcelRequire("c4sKh");

const $26451f799052e0a3$var$badgeStyles = null; /**
                           * A base element that displays a visual indicator for a numeric value
                           * @internal
                           * @see StoryPoints
                           * */ 
const $26451f799052e0a3$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), null, value));
};
var $26451f799052e0a3$export$2e2bcd8739ae039 = $26451f799052e0a3$var$BaseAtlaskitElementBadge;
const $26451f799052e0a3$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};


const $92f590de7cb9f9cd$var$StoryPointsElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $26451f799052e0a3$export$731812b93bd90554)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26451f799052e0a3$export$2e2bcd8739ae039), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).StoryPoints
    }) : null;
};
var $92f590de7cb9f9cd$export$2e2bcd8739ae039 = $92f590de7cb9f9cd$var$StoryPointsElement;
module.exports["default"] = $92f590de7cb9f9cd$export$2e2bcd8739ae039;

});

parcelRegister("hIbqn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $9a81c9be82c9d19d$var$TargetBranchElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).TargetBranch
    }) : null;
};
var $9a81c9be82c9d19d$export$2e2bcd8739ae039 = $9a81c9be82c9d19d$var$TargetBranchElement;
module.exports["default"] = $9a81c9be82c9d19d$export$2e2bcd8739ae039;

});

parcelRegister("gHW9t", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $8bb8e = parcelRequire("8bb8e");

const $b6969367f8b7bc15$var$TitleElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bb8e.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Title
    }) : null;
};
var $b6969367f8b7bc15$export$2e2bcd8739ae039 = $b6969367f8b7bc15$var$TitleElement;
module.exports["default"] = $b6969367f8b7bc15$export$2e2bcd8739ae039;

});

parcelRegister("zH0mb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $5c7b8fd91da848f0$var$ViewCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).View,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ViewCount
    }) : null;
};
var $5c7b8fd91da848f0$export$2e2bcd8739ae039 = $5c7b8fd91da848f0$var$ViewCountElement;
module.exports["default"] = $5c7b8fd91da848f0$export$2e2bcd8739ae039;

});

parcelRegister("6LJqp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $1a9391f1b33e2cfa$var$VoteCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).VoteCount
    }) : null;
};
var $1a9391f1b33e2cfa$export$2e2bcd8739ae039 = $1a9391f1b33e2cfa$var$VoteCountElement;
module.exports["default"] = $1a9391f1b33e2cfa$export$2e2bcd8739ae039;

});

parcelRegister("1RvsP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $l7DP7 = parcelRequire("l7DP7");

const $16630f477b2fdaf3$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $16630f477b2fdaf3$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $16630f477b2fdaf3$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $16630f477b2fdaf3$var$baseStyles = null;
const $16630f477b2fdaf3$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $16630f477b2fdaf3$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $16630f477b2fdaf3$var$horizontalStyleBase = null;
const $16630f477b2fdaf3$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $16630f477b2fdaf3$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $16630f477b2fdaf3$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $16630f477b2fdaf3$var$minWidthStyle = null; /**
                             * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                             * preferences.
                             * @internal
                             * @param {ActionGroupProps} ActionGroupProps
                             * @see Action
                             */ 
const $16630f477b2fdaf3$var$ElementGroup = ({ align: align = (0, $5TXU5.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5TXU5.SmartLinkDirection).Horizontal, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5TXU5.SmartLinkWidth).FitToContent, position: position = (0, $5TXU5.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5TXU5.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $16630f477b2fdaf3$var$baseStyleBySize[size],
            $16630f477b2fdaf3$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $16630f477b2fdaf3$var$alignmentStyleMap[align],
            "_1ul99by0",
            $16630f477b2fdaf3$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $16630f477b2fdaf3$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Left && $16630f477b2fdaf3$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Right && $16630f477b2fdaf3$var$gapStylesRight[size],
            $16630f477b2fdaf3$var$positionStyle[position],
            className
        ])
    }, (0, $l7DP7.renderChildren)(children, size));
};
var $16630f477b2fdaf3$export$2e2bcd8739ae039 = $16630f477b2fdaf3$var$ElementGroup;
module.exports["default"] = $16630f477b2fdaf3$export$2e2bcd8739ae039;

});

parcelRegister("cLh5D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9aGns = parcelRequire("9aGns");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $9oOnT = parcelRequire("9oOnT");


var $6FZ6a = parcelRequire("6FZ6a");

const $47aa84bed0904f6b$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).DownloadAction];
    const onClick = (0, $42omo.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $afp1H.messages).download_file : (0, $afp1H.messages).download;
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).download_description : (0, $afp1H.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $47aa84bed0904f6b$export$2e2bcd8739ae039 = $47aa84bed0904f6b$var$DownloadAction;
module.exports["default"] = $47aa84bed0904f6b$export$2e2bcd8739ae039;

});

parcelRegister("9l03X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $hJgLA = parcelRequire("hJgLA");





var $kKODE = parcelRequire("kKODE");


var $g98dH = parcelRequire("g98dH");


var $8i8ID = parcelRequire("8i8ID");


var $7DSoa = parcelRequire("7DSoa");

const $8421257f1cf5034c$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $8421257f1cf5034c$export$2e2bcd8739ae039 = $8421257f1cf5034c$var$createInvokeRequest;



var $6FZ6a = parcelRequire("6FZ6a");

const $a36d75dc0f2bdcbc$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const invoke = (0, $g98dH.default)();
    const reload = (0, $7DSoa.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $8421257f1cf5034c$export$2e2bcd8739ae039)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $8i8ID.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $a36d75dc0f2bdcbc$export$2e2bcd8739ae039 = $a36d75dc0f2bdcbc$var$ServerAction;








const $3c347798ab285251$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).follow_project_errorGalaxia : (0, $afp1H.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).unfollow_project_errorGalaxia : (0, $afp1H.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $afp1H.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $afp1H.messages).unfollow_goal_error;
    return (0, $afp1H.messages).generic_error_message;
};




const $fd35d1180b7d8d14$var$importIconMapper = {
    goal: ()=>(parcelRequire("bRnvt")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("9RQQm")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $fd35d1180b7d8d14$var$getIcon = (stackIconType)=>{
    const importFn = $fd35d1180b7d8d14$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $hJgLA.importIcon)(importFn);
};
const $fd35d1180b7d8d14$var$FollowAction = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const intl = (0, $aXWIB.useIntl)();
    const actionData = context?.actions?.[(0, $5TXU5.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $afp1H.messages).follow : (0, $afp1H.messages).unfollow;
    const projectMessage = value ? (0, $afp1H.messages).follow_project : (0, $afp1H.messages).unfollow_project;
    const goalMessage = value ? (0, $afp1H.messages).follow_goal : (0, $afp1H.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).follow_project_descriptionGalaxia : (0, $afp1H.messages).follow_project_description : (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).unfollow_project_descriptionGalaxia : (0, $afp1H.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $afp1H.messages).follow_goal_description : (0, $afp1H.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $fd35d1180b7d8d14$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $3c347798ab285251$export$49248678d3914625)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a36d75dc0f2bdcbc$export$2e2bcd8739ae039), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label),
        ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) ? {
            ariaLabel: intl.formatMessage(label)
        } : {},
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $fd35d1180b7d8d14$export$2e2bcd8739ae039 = $fd35d1180b7d8d14$var$FollowAction;
module.exports["default"] = $fd35d1180b7d8d14$export$2e2bcd8739ae039;

});

parcelRegister("bRnvt", function(module, exports) {

let $8a26e0dc99c728f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a26e0dc99c728f8$var$load("6wr18"),
    $8a26e0dc99c728f8$var$load("ffEVr"),
    $8a26e0dc99c728f8$var$load("3wY4G")
]).then(()=>parcelRequire('7EiCp'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("9RQQm", function(module, exports) {

let $72f20de99433ea06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72f20de99433ea06$var$load("6wr18"),
    $72f20de99433ea06$var$load("ffEVr"),
    $72f20de99433ea06$var$load("88r9N")
]).then(()=>parcelRequire('lwRK9'));

});

parcelRegister("2vLbR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lOzEN = parcelRequire("lOzEN");


var $jypE9 = parcelRequire("jypE9");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $k9nkv = parcelRequire("k9nkv");


var $9oOnT = parcelRequire("9oOnT");


var $6FZ6a = parcelRequire("6FZ6a");

const $b8c6ed50ac412c77$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).PreviewAction];
    const hasPreviewPanel = data?.hasPreviewPanel;
    const isRovoBlockCardExperimentEnabled = (0, $k9nkv.useBlockCardRovoActionExperimentNoExposure)();
    const onClick = (0, $42omo.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).preview_description : (0, $afp1H.messages).preview_improved;
    const actionIcon = (0, $42omo.useCallback)(()=>{
        // Only use panel icon if experiment is enabled and hasPreviewPanel is true
        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
            color: "currentColor",
            spacing: "spacious",
            label: (0, $dh538.fg)('navx-3698-flexible-card-a11y-fix') ? '' : 'Open preview panel',
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || isRovoBlockCardExperimentEnabled || (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) ? {
                size: props.iconSize
            } : {}
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
            color: "currentColor",
            spacing: "spacious",
            label: (0, $dh538.fg)('navx-3698-flexible-card-a11y-fix') ? '' : 'Open preview',
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || isRovoBlockCardExperimentEnabled || (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) ? {
                size: props.iconSize
            } : {}
        });
    }, [
        hasPreviewPanel,
        props.iconSize,
        isRovoBlockCardExperimentEnabled
    ]);
    const actionLabel = (0, $42omo.useCallback)(()=>{
        // Only use panel message if experiment is enabled and hasPreviewPanel is true
        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).preview_panel);
        // Fall back to modal message if experiment is enabled, otherwise use original preview message
        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).preview_modal);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).preview_improved);
    }, [
        hasPreviewPanel
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: actionLabel(),
        icon: actionIcon(),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $b8c6ed50ac412c77$export$2e2bcd8739ae039 = $b8c6ed50ac412c77$var$PreviewAction;
module.exports["default"] = $b8c6ed50ac412c77$export$2e2bcd8739ae039;

});

parcelRegister("apOlf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1bY7o = parcelRequire("1bY7o");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $k9nkv = parcelRequire("k9nkv");


var $9oOnT = parcelRequire("9oOnT");


var $6FZ6a = parcelRequire("6FZ6a");

const $a91d440270dbacf8$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_url_to_clipboard);
    const isRovoBlockCardExperimentEnabled = (0, $k9nkv.useBlockCardRovoActionExperimentNoExposure)();
    const onClick = (0, $42omo.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $afp1H.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).copy_url_to_clipboard),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            color: "currentColor",
            label: (0, $dh538.fg)('navx-3698-flexible-card-a11y-fix') ? '' : 'copy url',
            spacing: "spacious",
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || isRovoBlockCardExperimentEnabled || (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) ? {
                size: props.iconSize
            } : {}
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $a91d440270dbacf8$export$2e2bcd8739ae039 = $a91d440270dbacf8$var$CopyLinkAction;
module.exports["default"] = $a91d440270dbacf8$export$2e2bcd8739ae039;

});

parcelRegister("lVA2Y", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

const $a1261186af9b2859$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $a1261186af9b2859$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $1Whri.cx)($a1261186af9b2859$var$styles.message, hasPadding && $a1261186af9b2859$var$styles.padding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...descriptor,
        values: values
    }));
    return hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $a1261186af9b2859$var$styles.button
    }, message) : message;
};
var $a1261186af9b2859$export$2e2bcd8739ae039 = $a1261186af9b2859$var$UnresolvedAction;
module.exports["default"] = $a1261186af9b2859$export$2e2bcd8739ae039;

});

parcelRegister("f0sMY", function(module, exports) {

let $aecd2ffdab158a29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aecd2ffdab158a29$var$load("6wr18"),
    $aecd2ffdab158a29$var$load("kHOMt"),
    $aecd2ffdab158a29$var$load("ffEVr"),
    $aecd2ffdab158a29$var$load("hhss7"),
    $aecd2ffdab158a29$var$load("7EorR"),
    $aecd2ffdab158a29$var$load("Wowvf"),
    $aecd2ffdab158a29$var$load("etEYy"),
    $aecd2ffdab158a29$var$load("cqZpg")
]).then(()=>parcelRequire('iWqmE'));

});

parcelRegister("aEcBF", function(module, exports) {

let $7c076b363390ca64$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7c076b363390ca64$var$load("5ksq8"),
    $7c076b363390ca64$var$load("etEYy"),
    $7c076b363390ca64$var$load("hhss7"),
    $7c076b363390ca64$var$load("aoU9B")
]).then(()=>parcelRequire('a6OFr'));

});

parcelRegister("2R1C4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $l7DP7 = parcelRequire("l7DP7");

const $1ab21bb04b9ccb77$var$baseBlockStyles = null;
const $1ab21bb04b9ccb77$var$highlightRemoveStyles = null;
const $1ab21bb04b9ccb77$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $1ab21bb04b9ccb77$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
}; /**
    * A block represents a collection of elements and actions that are arranged
    * in a row. All elements and actions should be contained within a Block.
    * @internal
    * @param {ActionGroupProps} ActionGroupProps
    * @see Action
    */ 
const $1ab21bb04b9ccb77$var$Block = ({ children: children, direction: direction = (0, $5TXU5.SmartLinkDirection).Horizontal, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $42omo.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bx1l7x _e4i5bjq5 _1gu2dgkc _5b7tuxlv _17aedgkc",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $1ab21bb04b9ccb77$var$directionStyles[direction],
            $1ab21bb04b9ccb77$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId
    }, (0, $l7DP7.renderChildren)(children, size));
};
var $1ab21bb04b9ccb77$export$2e2bcd8739ae039 = $1ab21bb04b9ccb77$var$Block;
module.exports["default"] = $1ab21bb04b9ccb77$export$2e2bcd8739ae039;

});

parcelRegister("1lLfV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $2R1C4 = parcelRequire("2R1C4");


var $1RvsP = parcelRequire("1RvsP");


var $l7DP7 = parcelRequire("l7DP7");

const $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES = 2;
const $8e07cec8e3b2cb3b$var$MAXIMUM_MAX_LINES = 2;
const $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES = 1;
const $8e07cec8e3b2cb3b$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $8e07cec8e3b2cb3b$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $8e07cec8e3b2cb3b$var$getMaxLines = (maxLines)=>{
    if (maxLines > $8e07cec8e3b2cb3b$var$MAXIMUM_MAX_LINES) return $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES;
    if (maxLines < $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES) return $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $8e07cec8e3b2cb3b$var$ElementItemRenderer = ({ align: align = (0, $5TXU5.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5TXU5.SmartLinkSize).Medium, maxLines: maxLines = $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $l7DP7.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        align: align,
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $gMc0m.default)([
            $8e07cec8e3b2cb3b$var$truncateStyles[maxLines],
            $8e07cec8e3b2cb3b$var$sizeStyles[size]
        ])
    }, elements);
}; /**
    * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
    * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
    * @public
    * @param {MetadataBlockProps} MetadataBlockProps
    * @see Block
    */ 
const $8e07cec8e3b2cb3b$var$MetadataBlock = ({ maxLines: maxLines = $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $5TXU5.SmartLinkSize).Medium;
    const maxLinesTotal = $8e07cec8e3b2cb3b$var$getMaxLines(maxLines);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ $42omo.createElement($8e07cec8e3b2cb3b$var$ElementItemRenderer, {
        items: primary,
        size: size,
        maxLines: maxLinesTotal
    }), /*#__PURE__*/ $42omo.createElement($8e07cec8e3b2cb3b$var$ElementItemRenderer, {
        align: (0, $5TXU5.SmartLinkAlignment).Right,
        items: secondary,
        size: size,
        maxLines: maxLinesTotal
    }));
};
var $8e07cec8e3b2cb3b$export$2e2bcd8739ae039 = $8e07cec8e3b2cb3b$var$MetadataBlock;
module.exports["default"] = $8e07cec8e3b2cb3b$export$2e2bcd8739ae039;

});

parcelRegister("Y5kOr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fUfR2 = parcelRequire("fUfR2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $ikM9T = parcelRequire("ikM9T");


var $2R1C4 = parcelRequire("2R1C4");

const $2fe31e0809d9677b$var$previewBlockStyleCommon = null;
const $2fe31e0809d9677b$var$ignoreContainerPaddingStyle = null; /**
                                           * Represents a resolved PreviewBlock, which typically contains media or other large format content.
                                           * @public
                                           * @param {PreviewBlock} PreviewBlock
                                           * @see Block
                                           */ 
const $2fe31e0809d9677b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $42omo.useState)(()=>{
        if ((0, $dh538.fg)('dfo-fix-preview-dynamic-style')) {
            if (placement === (0, $5TXU5.MediaPlacement).Left || placement === (0, $5TXU5.MediaPlacement).Right) {
                const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
                const newStyle = {
                    ...style,
                    position: 'absolute',
                    top: containerPadding,
                    bottom: containerPadding,
                    width: `calc(var(--preview-block-width) - ${containerPadding})`,
                    ...placement === (0, $5TXU5.MediaPlacement).Left ? {
                        left: containerPadding
                    } : {},
                    ...placement === (0, $5TXU5.MediaPlacement).Right ? {
                        right: containerPadding
                    } : {}
                };
                return newStyle;
            }
        }
        return style ?? {};
    });
    const updateStyles = (0, $42omo.useCallback)(()=>{
        if (placement === (0, $5TXU5.MediaPlacement).Left || placement === (0, $5TXU5.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5TXU5.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5TXU5.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    // Should be useLayoutEffect to avoid flicker.
    // Styles should be set before paint.
    (0, $42omo.useLayoutEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $42omo.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $42omo.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        style: dynamicStyles,
        className: (0, $gMc0m.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ikM9T.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $2fe31e0809d9677b$export$2e2bcd8739ae039 = $2fe31e0809d9677b$var$PreviewBlockResolvedView;


/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $3da662f4fc394f2e$var$PreviewBlock = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2fe31e0809d9677b$export$2e2bcd8739ae039), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $3da662f4fc394f2e$export$2e2bcd8739ae039 = $3da662f4fc394f2e$var$PreviewBlock;
module.exports["default"] = $3da662f4fc394f2e$export$2e2bcd8739ae039;

});

parcelRegister("8zS2j", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $4QzTV = parcelRequire("4QzTV");


var $49WiA = parcelRequire("49WiA");


var $hJgLA = parcelRequire("hJgLA");


var $2R1C4 = parcelRequire("2R1C4");

const $60c86a1fbc149797$var$DEFAULT_MAX_LINES = 3;
const $60c86a1fbc149797$var$MAXIMUM_MAX_LINES = 6;
const $60c86a1fbc149797$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $60c86a1fbc149797$var$SnippetBlock = ({ maxLines: maxLines = $60c86a1fbc149797$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const renderers = (0, $4QzTV.useSmartLinkRenderers)();
    const enableSnippetRenderer = (0, $fUfR2.useFlexibleUiOptionContext)()?.enableSnippetRenderer;
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $hJgLA.getMaxLines)(maxLines, $60c86a1fbc149797$var$DEFAULT_MAX_LINES, $60c86a1fbc149797$var$MAXIMUM_MAX_LINES, $60c86a1fbc149797$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49WiA.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!enableSnippetRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`
    }, snippet);
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`
    }, SnippetReplacement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SnippetReplacement, {
        fallbackText: (text || context?.snippet) ?? '',
        fallbackComponent: snippet,
        contentId: context?.meta?.objectId ?? '',
        contentType: context?.meta?.resourceType ?? '',
        cloudId: context?.meta?.tenantId ?? '',
        maxLines: snippetMaxLines,
        isHidden: isHidden,
        showFooter: showFooter
    }) : snippet);
};
var $60c86a1fbc149797$export$2e2bcd8739ae039 = $60c86a1fbc149797$var$SnippetBlock;
module.exports["default"] = $60c86a1fbc149797$export$2e2bcd8739ae039;

});

parcelRegister("5znEc", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $4gM1A = parcelRequire("4gM1A");


var $fUfR2 = parcelRequire("fUfR2");


var $gHW9t = parcelRequire("gHW9t");


var $7d67T = parcelRequire("7d67T");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gdv5Z = parcelRequire("gdv5Z");








var $lVA2Y = parcelRequire("lVA2Y");


var $jI5eg = parcelRequire("jI5eg");


var $2R1C4 = parcelRequire("2R1C4");


var $1RvsP = parcelRequire("1RvsP");

const $7f525c54e6e1b7b1$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $7f525c54e6e1b7b1$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: _retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, ...blockProps })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction]);
    const competitorPrompt = CompetitorPrompt && context?.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CompetitorPrompt, {
        sourceUrl: context?.url,
        linkType: 'card'
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jI5eg.default), {
        overrideIcon: icon,
        position: position
    }), competitorPrompt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $7f525c54e6e1b7b1$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, showRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1RvsP.default), {
        align: (0, $5TXU5.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lVA2Y.default), {
        testId: testId
    })), actionGroup);
};
var $7f525c54e6e1b7b1$export$2e2bcd8739ae039 = $7f525c54e6e1b7b1$var$TitleBlockErroredView;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















var $l7DP7 = parcelRequire("l7DP7");

const $c1792527dfb9ef73$var$style = null;
const $c1792527dfb9ef73$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
}; /**
    * This renders a fully resolved TitleBlock.
    * This should render when a Smart Link returns a valid response.
    * @see TitleBlock
    */ 
const $c1792527dfb9ef73$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: _text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $l7DP7.renderElementItems)(metadata);
    const subtitleElements = (0, $l7DP7.renderElementItems)(subtitle);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ $42omo.createElement((0, $jI5eg.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: hideIconLoadingSkeleton
    }), /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        size: blockProps.size,
        className: (0, $gMc0m.default)([
            "_zulp1b66"
        ])
    }, CompetitorPrompt && url ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $c1792527dfb9ef73$var$styles.titleBox
    }, title, /*#__PURE__*/ $42omo.createElement(CompetitorPrompt, {
        sourceUrl: url,
        linkType: 'card'
    })) : title, subtitleElements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        align: (0, $5TXU5.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $5TXU5.SmartLinkPosition).Center,
        size: blockProps.size
    }, metadataElements), actionGroup);
};
var $c1792527dfb9ef73$export$2e2bcd8739ae039 = $c1792527dfb9ef73$var$TitleBlockResolvedView;


/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 






var $17It2 = parcelRequire("17It2");





var $hJgLA = parcelRequire("hJgLA");




/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $835b2d1437edfc5d$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, icon: icon, position: position, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5TXU5.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $hJgLA.getIconWidth)(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jI5eg.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: true
    }), !hideIcon && !icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            width: iconWidth,
            height: iconWidth
        },
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $17It2.LoadingSkeleton), {
        width: iconWidth,
        height: iconWidth,
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $835b2d1437edfc5d$export$2e2bcd8739ae039 = $835b2d1437edfc5d$var$TitleBlockResolvingView;


const $86a4ce57d2ec07f2$var$actionStyles = null;
const $86a4ce57d2ec07f2$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Pending:
        case (0, $5TXU5.SmartLinkStatus).Resolving:
            return 0, $835b2d1437edfc5d$export$2e2bcd8739ae039;
        case (0, $5TXU5.SmartLinkStatus).Resolved:
            return 0, $c1792527dfb9ef73$export$2e2bcd8739ae039;
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).NotFound:
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return 0, $7f525c54e6e1b7b1$export$2e2bcd8739ae039;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $86a4ce57d2ec07f2$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    const { status: status = (0, $5TXU5.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $42omo.useState)(false);
    const onDropdownOpenChange = (0, $42omo.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $7d67T.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const title = /*#__PURE__*/ $42omo.createElement((0, $gHW9t.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $86a4ce57d2ec07f2$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ $42omo.createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        className: (0, $gMc0m.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $86a4ce57d2ec07f2$export$2e2bcd8739ae039 = $86a4ce57d2ec07f2$var$TitleBlock;
module.exports["default"] = $86a4ce57d2ec07f2$export$2e2bcd8739ae039;

});

parcelRegister("eqpYq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");





var $afp1H = parcelRequire("afp1H");


var $6KV13 = parcelRequire("6KV13");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $e6pbP = parcelRequire("e6pbP");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");

/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $bd7359d17942e8a2$var$listStyles = null;
const $bd7359d17942e8a2$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        ...props,
        className: (0, $gMc0m.default)([
            "_19bvv47k _bozgv47k"
        ])
    }, children);
var $bd7359d17942e8a2$export$2e2bcd8739ae039 = $bd7359d17942e8a2$var$UList;


const $9338d7fc86a81ff5$var$baseStyle = null;
const $9338d7fc86a81ff5$var$textStyleNew = null;
const $9338d7fc86a81ff5$var$textStyleOld = null; /**
                            * A component to render a response from AI in markdown text.
                            * @internal
                            * @param {AISummaryProps} AISummaryProps
                            */ 
const $9338d7fc86a81ff5$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    const is3pExperimentEnabled = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') && (0, $dZ8uq.expValEqualsNoExposure)('platform_sl_3p_auth_rovo_action', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('rovogrowth-640-inline-action-nudge-fg') && (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true);
    return /*#__PURE__*/ $42omo.createElement((0, $e6pbP.default), {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            is3pExperimentEnabled ? "_syazi7uo" : "_syazazsu",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $bd7359d17942e8a2$export$2e2bcd8739ae039)
            },
            disableParsingRawHTML: true
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $9338d7fc86a81ff5$export$2e2bcd8739ae039 = $9338d7fc86a81ff5$var$AISummary;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $8tSmd = parcelRequire("8tSmd");


var $2Nwuj = parcelRequire("2Nwuj");















const $ba3699740c57099b$var$styles = {
    aiFooterWrapper: "_ca0q1b66"
};
const $ba3699740c57099b$var$AIFooter = ()=>/*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $ba3699740c57099b$var$styles.aiFooterWrapper
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
        label: "",
        color: "var(--ds-text-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small"
    }, /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
        href: (0, $dh538.fg)('platform_sl_ai_summary_rebrand') ? (0, $5TXU5.CONTENT_URL_ROVO) : 'https://www.atlassian.com/trust/atlassian-intelligence',
        appearance: "subtle",
        target: "_blank"
    }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).ai_disclaimer))));
var $ba3699740c57099b$export$2e2bcd8739ae039 = $ba3699740c57099b$var$AIFooter;



var $6bBFP = parcelRequire("6bBFP");


var $2R1C4 = parcelRequire("2R1C4");





var $kKODE = parcelRequire("kKODE");

const $f7f9db9fca31c767$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f7f9db9fca31c767$export$2e2bcd8739ae039 = $f7f9db9fca31c767$var$AIEventSummaryViewed;


/* ellipses.tsx generated by @compiled/babel-plugin v0.36.1 */ // Copied from platform/packages/ai-mate/rovo-platform-ui-components/src/ui/primitives/ellipses-animation/EllipsesAnimation.tsx






const $2a4b4233e8981c08$var$animation = null;
const $2a4b4233e8981c08$var$animation1 = null;
const $2a4b4233e8981c08$var$animation2 = null;
const $2a4b4233e8981c08$var$dot1 = null;
const $2a4b4233e8981c08$var$dot2 = null;
const $2a4b4233e8981c08$var$dot3 = null;
const $2a4b4233e8981c08$var$animatedOpacity = null;
const $2a4b4233e8981c08$export$c0e6915bcce7d1d0 = ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $42omo.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            isAnimated && "",
            isAnimated && "_y44v1gpk",
            isAnimated && $2a4b4233e8981c08$var$animatedOpacity
        ]),
        d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ $42omo.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            isAnimated && "",
            isAnimated && "_y44v18gg",
            isAnimated && $2a4b4233e8981c08$var$animatedOpacity
        ]),
        d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ $42omo.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            isAnimated && "",
            isAnimated && "_y44voqx9",
            isAnimated && $2a4b4233e8981c08$var$animatedOpacity
        ]),
        d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
        fill: "#FCA700"
    }));
};


const $6916bf0a97d23595$var$styles = null;
const $6916bf0a97d23595$var$newStyles = {
    iconWrapper: "_19bv1b66 _u5f3utpp _1e0c1txw _4cvr1h6o",
    placeholderWrapper: "_1e0c1txw _4cvr1h6o",
    summaryWrapper: "_ca0q1b66 _1e0c1txw",
    ellipsesContainer: "_19bv1b66"
};
const $6916bf0a97d23595$var$AISummaryBlockResolvedView = (props)=>{
    (0, $fBMbo.di)((0, $6KV13.default), (0, $9338d7fc86a81ff5$export$2e2bcd8739ae039));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $6KV13.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $42omo.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, placeholder);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, status === 'done' && /*#__PURE__*/ $42omo.createElement((0, $f7f9db9fca31c767$export$2e2bcd8739ae039), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $42omo.createElement((0, $9338d7fc86a81ff5$export$2e2bcd8739ae039), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
const $6916bf0a97d23595$export$3570243fee4941c9 = (props)=>{
    (0, $fBMbo.di)((0, $6KV13.default), (0, $9338d7fc86a81ff5$export$2e2bcd8739ae039));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $6KV13.default)(url);
    const isSummarisedOnMountRef = (0, $42omo.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (status === 'error') return null;
     // Show summary when there is content to display
    if (content && content !== '') return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        xcss: $6916bf0a97d23595$var$newStyles.summaryWrapper
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6916bf0a97d23595$var$newStyles.iconWrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.RovoIcon), {
        shouldUseHexLogo: true,
        size: "xxsmall"
    })), status === 'done' && /*#__PURE__*/ $42omo.createElement((0, $f7f9db9fca31c767$export$2e2bcd8739ae039), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        minHeight: minHeight,
        show: true,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $42omo.createElement((0, $9338d7fc86a81ff5$export$2e2bcd8739ae039), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    }), status === 'done' && /*#__PURE__*/ $42omo.createElement((0, $ba3699740c57099b$export$2e2bcd8739ae039), null))));
     // Show loading state on initial request where content hasn't returned yet.
    if (status === 'loading') return /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        minHeight: minHeight,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        testId: `${testId}-placeholder`,
        xcss: $6916bf0a97d23595$var$newStyles.placeholderWrapper
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6916bf0a97d23595$var$newStyles.iconWrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.RovoIcon), {
        shouldUseHexLogo: true,
        size: 'xxsmall'
    })), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text"
    }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).rovo_summary_loading)), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $6916bf0a97d23595$var$newStyles.ellipsesContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $2a4b4233e8981c08$export$c0e6915bcce7d1d0), {
        isAnimated: true
    }))));
     // Otherwise, show placeholder if provided
    if (placeholder) return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, placeholder);
    return null;
};
var $6916bf0a97d23595$export$2e2bcd8739ae039 = $6916bf0a97d23595$var$AISummaryBlockResolvedView;


/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $3d73a30329f2f2d2$var$AISummaryBlock = ({ isAny3pRovoActionsExperimentOn: isAny3pRovoActionsExperimentOn, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    if (isAny3pRovoActionsExperimentOn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6916bf0a97d23595$export$3570243fee4941c9), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6916bf0a97d23595$export$2e2bcd8739ae039), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
var $3d73a30329f2f2d2$export$2e2bcd8739ae039 = $3d73a30329f2f2d2$var$AISummaryBlock;
module.exports["default"] = $3d73a30329f2f2d2$export$2e2bcd8739ae039;

});

parcelRegister("MlN47", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");











var $2ZgNz = parcelRequire("2ZgNz");


var $2R1C4 = parcelRequire("2R1C4");





var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $gNXND = parcelRequire("gNXND");


var $3Mg7y = parcelRequire("3Mg7y");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $3gadb = parcelRequire("3gadb");


var $afp1H = parcelRequire("afp1H");


var $6KV13 = parcelRequire("6KV13");





var $eXmBZ = parcelRequire("eXmBZ");

const $b60461a0f2dc3b3a$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        color: props.color || 'currentColor',
        ...props
    });


const $b7fbd07145f71993$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $fBMbo.di)((0, $6KV13.default));
    const { state: { status: status } } = (0, $6KV13.default)(url);
    if (status !== 'done') return null;
    const Icon = (0, $dh538.fg)('platform_sl_ai_summary_rebrand') ? (0, (/*@__PURE__*/$parcel$interopDefault($gNXND))) : (0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b60461a0f2dc3b3a$export$2957fc44b3d2481), {
            label: "Information",
            color: "var(--ds-icon-subtle, #505258)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "AI",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};


const $92f251934aee2626$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZgNz.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7fbd07145f71993$export$175228cc2c92b3b6), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $92f251934aee2626$export$2e2bcd8739ae039 = $92f251934aee2626$var$AIFooterBlockResolvedView;


/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $38aa18aa215cb0bb$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92f251934aee2626$export$2e2bcd8739ae039), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $38aa18aa215cb0bb$export$2e2bcd8739ae039 = $38aa18aa215cb0bb$var$AIFooterBlock;
module.exports["default"] = $38aa18aa215cb0bb$export$2e2bcd8739ae039;

});

parcelRegister("7Twup", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $jlQ9A = parcelRequire("jlQ9A");


var $2ZgNz = parcelRequire("2ZgNz");


var $2R1C4 = parcelRequire("2R1C4");

const $a23285dcc916d065$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS = [
    (0, $5TXU5.ActionName).RovoChatAction
];
const $a23285dcc916d065$var$ignoreContainerMarginStyles = null;
const $a23285dcc916d065$var$inlineActionNudgeFooterMarginStyles = null;
const $a23285dcc916d065$var$elevatedFooterStyles = null;
const $a23285dcc916d065$var$providerStyles = null;
const $a23285dcc916d065$var$actionsStyles = null; /**
                             * Footer block for HoverCard resolved view: Provider on the left, ActionGroup (up to 4 actions) on the right.
                             * @internal
                             * @param {ResolvedHoverCardFooterBlockProps} ResolvedHoverCardFooterBlockProps
                             * @see Block
                             */ 
const $a23285dcc916d065$var$ResolvedHoverCardFooterBlock = ({ testId: testId = 'smart-hover-card-footer-block', onActionClick: onActionClick, hideProvider: hideProvider, ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const size = props.size ?? cardContext?.ui?.size;
    const actions = (0, $42omo.useMemo)(()=>{
        if (!context?.actions) return [];
        let arr = Object.keys(context.actions);
        arr = arr.filter((name)=>!$a23285dcc916d065$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS.includes(name));
        return arr.map((name)=>{
            const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
            return Action ? /*#__PURE__*/ $42omo.createElement(Action, {
                key: name,
                as: "stack-item",
                content: "",
                onClick: ()=>onActionClick?.(name),
                size: size,
                iconSize: 'small'
            }) : null;
        });
    }, [
        context?.actions,
        onActionClick,
        size
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        size: size,
        testId: `${testId}-resolved-view`,
        className: (0, $gMc0m.default)([
            "_18zrpxbi _1rjcutpp _vchhusvi _1bsb129b _18u01ivi _2hwxc10g _otyr1ya9 _4t3ioahv",
            "_zulpu2gc _x3doj0fz _bfhkhfxm _mrkb1mok _1o0z1mok",
            (0, $dh538.fg)('rovogrowth-640-inline-action-nudge-fg') && (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) && "_19pkutpp"
        ])
    }, !hideProvider && /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3i1ejb _1e0c1txw _4cvr1h6o _1bah1y6m _vchhusvi _16jlkb7n"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2ZgNz.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    })), actions.length > 0 ? /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": `${testId}-actions`,
        className: (0, $gMc0m.default)([
            "_zulpidpf _1e0c1txw _18u01wug _4cvr1h6o _vchhusvi _7386ze3t _1xdd12b0 _17zize3t _19p4ze3t _6zimze3t _f9lhze3t _rvy9ze3t _ue4dze3t _zgrbze3t _10cuze3t _6syfze3t _3hv7ze3t"
        ])
    }, actions) : null);
};
var $a23285dcc916d065$export$2e2bcd8739ae039 = $a23285dcc916d065$var$ResolvedHoverCardFooterBlock;
module.exports["default"] = $a23285dcc916d065$export$2e2bcd8739ae039;

});

parcelRegister("f0wtW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fBMbo = parcelRequire("fBMbo");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $jlQ9A = parcelRequire("jlQ9A");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $a3fRD = parcelRequire("a3fRD");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $6bBFP = parcelRequire("6bBFP");

const $dfe1275874cc34dc$var$styles = {
    containerStyles: "_kkk2n7od _2rko12b0 _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8wadc _syazazsu"
};
const $dfe1275874cc34dc$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                testId: "action-error-icon",
                size: "small"
            });
        default:
            return null;
    }
};
const $dfe1275874cc34dc$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $dfe1275874cc34dc$var$styles.containerStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "start",
        grow: "fill",
        space: "space.075",
        xcss: $dfe1275874cc34dc$var$styles.errorContentStyles
    }, message.icon || $dfe1275874cc34dc$var$getIcon(message.appearance), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $dfe1275874cc34dc$var$styles.titleStyles
    }, message.title))));
};


/* ask-rovo-section-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $aXWIB = parcelRequire("aXWIB");


var $afp1H = parcelRequire("afp1H");




const $2f75139b98c9a88d$var$RovoHexLogo = ({ width: width = 16, height: height = 16, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.32082 0.180234C7.74137 -0.0600783 8.25764 -0.0600779 8.67819 0.180234L14.4919 3.50235C14.9181 3.7459 15.1811 4.19916 15.1811 4.69005V11.31C15.1811 11.8008 14.9181 12.2541 14.4919 12.4976L8.67819 15.8198C8.25764 16.0601 7.74137 16.0601 7.32082 15.8198L1.50712 12.4976C1.08091 12.2541 0.817871 11.8008 0.817871 11.31V4.69005C0.817871 4.19916 1.08091 3.7459 1.50712 3.50235L7.32082 0.180234Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "rovo-hex-logo-mask",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "16",
        height: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.32131 0.180234C7.74186 -0.0600783 8.25813 -0.0600779 8.67868 0.180234L14.4924 3.50235C14.9186 3.7459 15.1816 4.19916 15.1816 4.69005V11.31C15.1816 11.8008 14.9186 12.2541 14.4924 12.4976L8.67868 15.8198C8.25813 16.0601 7.74186 16.0601 7.32131 15.8198L1.50761 12.4976C1.08139 12.2541 0.818359 11.8008 0.818359 11.31V4.69005C0.818359 4.19916 1.08139 3.7459 1.50761 3.50235L7.32131 0.180234Z",
        fill: "#BF63F3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        mask: "url(#rovo-hex-logo-mask)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.55034 23.7263C2.51722 21.8759 3.92904 20.4254 5.78825 19.4378C7.64746 18.4502 9.80649 18.0272 11.9924 18.2787L0.232859 -3.40716C-1.71715 -3.05431 -3.61315 -2.40324 -5.43793 -1.43392C-7.26271 -0.464597 -8.83182 0.695804 -10.1944 2.06176L1.55525 23.7295L1.55034 23.7263Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.32996 10.6048C5.08544 11.9472 2.60753 14.1646 2.50661 17.2335C2.50661 17.2335 2.50834 17.2492 2.5067 17.2569C2.50006 17.4849 2.50431 17.7155 2.52528 17.9508C2.52613 17.9528 2.52697 17.9548 2.52782 17.9568C2.54755 18.195 2.58193 18.4389 2.63013 18.6865C2.64247 18.7448 2.66068 18.8053 2.67303 18.8635C2.71727 19.0611 2.76151 19.2587 2.82541 19.4622C2.91006 19.7323 3.0085 20.006 3.12662 20.2856C3.34515 20.803 3.60149 21.2648 3.87811 21.6759C4.24638 22.2229 4.65025 22.6799 5.05256 23.0579C5.15366 23.1522 5.25307 23.2424 5.35496 23.327C5.82852 23.6473 6.52024 24.0721 7.67929 24.611C8.43636 24.9641 9.39801 25.3664 10.6295 25.8214C11.6142 24.3227 13.4162 23.1571 15.1026 21.8515C16.434 20.8196 17.6899 19.7016 18.4057 18.2626C19.0622 16.9444 19.0793 15.3018 18.3596 13.5979C16.5583 9.33325 12.571 8.84764 8.33329 10.6011L8.32996 10.6048Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.5504 -10.1487L-3.75363 -6.70421C-3.75363 -6.70421 -1.76588 2.02941 -6.08056 9.9801C-5.48977 10.025 -4.8921 10.052 -4.28777 10.0436C6.82615 9.88862 15.707 0.847682 15.5504 -10.1523L15.5504 -10.1487Z",
        fill: "#1868DB"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.56286 3.61843C7.87582 3.44569 8.2578 3.44886 8.56822 3.62795L11.5883 5.37155C11.9043 5.5539 12.1 5.89221 12.1 6.25667V9.74392C12.1 10.1098 11.9055 10.4466 11.5885 10.6289L9.31833 11.9396C9.3233 11.9256 9.32804 11.9115 9.33255 11.8974C9.37469 11.7667 9.39702 11.6287 9.39702 11.4875V8.00029C9.39702 7.52122 9.14221 7.07944 8.7266 6.84045L7.03432 5.86386V4.51304C7.03432 4.4066 7.05078 4.30262 7.08192 4.20419C7.15847 3.96597 7.3213 3.75973 7.54405 3.63099L7.54473 3.6306C7.55112 3.62692 7.55719 3.62283 7.56286 3.61843Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.79433 4.06439L4.52416 5.37506C4.20715 5.55732 4.0127 5.89413 4.0127 6.26003V9.74729C4.0127 10.1117 4.20829 10.45 4.52436 10.6324L7.54444 12.376C7.85486 12.5551 8.23686 12.5583 8.5498 12.3855C8.55547 12.3811 8.5615 12.3771 8.56789 12.3734C8.79089 12.2447 8.95396 12.0384 9.03064 11.8001C9.06185 11.7016 9.07834 11.5975 9.07834 11.4909V10.1401L7.38617 9.16356C6.97063 8.92455 6.71564 8.48268 6.71564 8.00366V4.5164C6.71564 4.37548 6.73791 4.2376 6.77994 4.1071C6.7845 4.09277 6.7893 4.07853 6.79433 4.06439Z",
        fill: "white"
    }));
$2f75139b98c9a88d$var$RovoHexLogo.displayName = 'RovoHexLogo';
var $2f75139b98c9a88d$export$2e2bcd8739ae039 = $2f75139b98c9a88d$var$RovoHexLogo;


const $8093cd8f55cc887e$var$sectionHeaderStyles = null;
const $8093cd8f55cc887e$var$sectionHeaderDividerStyles = null;
const $8093cd8f55cc887e$var$sectionHeaderRowStyles = null;
const $8093cd8f55cc887e$var$sectionHeaderLabelStyles = null;
const $8093cd8f55cc887e$var$AskRovoSectionHeader = ({ testId: testId })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_zulputpp _1e0c1txw _2lx21bp4 _otyrutpp _18u0v77o _1bsb1osq _1wpz1fhb"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        role: "separator",
        "aria-orientation": "horizontal",
        className: (0, $gMc0m.default)([
            "_4t3it94y _1bsb1osq _bfhk1l7x"
        ])
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _19bv1b66"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2f75139b98c9a88d$export$2e2bcd8739ae039), null), /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazazsu _k48p1wq8"
        ])
    }, intl.formatMessage((0, $afp1H.messages).rovo_chat_action_section_header))));
};
var $8093cd8f55cc887e$export$2e2bcd8739ae039 = $8093cd8f55cc887e$var$AskRovoSectionHeader;


const $018f38f6aa2eb81b$var$ignoreContainerPaddingStyles = null;
const $018f38f6aa2eb81b$var$inlineActionNudgePillWrapperStyles = null;
const $018f38f6aa2eb81b$var$inlineActionNudgeColumnStyles = null;
const $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $018f38f6aa2eb81b$var$sort = (a, b)=>{
    let idxA = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
}; /**
    * Get container padding based on smart link size
    * To replace container/index.tsx getPadding() with space token for primitives
    */ 
const $018f38f6aa2eb81b$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $018f38f6aa2eb81b$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action', isAny3pRovoActionsExperimentOn: isAny3pRovoActionsExperimentOn })=>{
    (0, $fBMbo.di)((0, $dfe1275874cc34dc$export$2d2b754ac238f9aa));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const isRovoChatActionAvailable = ((0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || (0, $dh538.fg)('rovogrowth-640-inline-action-nudge-fg')) && isAny3pRovoActionsExperimentOn ? context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction] !== undefined : undefined; // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    const isInlineActionNudgeExperiment = (0, $dh538.fg)('rovogrowth-640-inline-action-nudge-fg') && (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true);
    const [message, setMessage] = (0, $42omo.useState)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const onLoadingChange = (0, $42omo.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $018f38f6aa2eb81b$export$1af10e3728e3a644(ui?.size || (0, $5TXU5.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $42omo.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $42omo.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $42omo.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || (0, $dh538.fg)('rovogrowth-640-inline-action-nudge-fg') ? isRovoChatActionAvailable ? [
            (0, $5TXU5.ActionName).RovoChatAction
        ] : Object.keys(context.actions).filter((name)=>name !== (0, $5TXU5.ActionName).RovoChatAction) : Object.keys(context.actions);
        arr.sort($018f38f6aa2eb81b$var$sort);
        const renderAction = (name)=>{
            const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
            if (!Action) return null;
            return /*#__PURE__*/ $42omo.createElement(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                style: !(isInlineActionNudgeExperiment && isRovoChatActionAvailable) && padding ? {
                    paddingInline: padding
                } : undefined,
                hideTooltip: isLoading
            });
        };
        return arr.map((name)=>renderAction(name));
    }, [
        context?.actions,
        isRovoChatActionAvailable,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick,
        isInlineActionNudgeExperiment
    ]);
    const showRovoSectionHeader = isInlineActionNudgeExperiment && isRovoChatActionAvailable;
    if (!actions) return null;
    if (isInlineActionNudgeExperiment && isRovoChatActionAvailable) return /*#__PURE__*/ $42omo.createElement("div", {
        ref: blockRef,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _1bsb1osq"
        ])
    }, showRovoSectionHeader && /*#__PURE__*/ $42omo.createElement((0, $8093cd8f55cc887e$export$2e2bcd8739ae039), {
        testId: testId ? `${testId}-rovo-section-header` : undefined
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c11p5 _yv0e1ris"
        ])
    }, actions), /*#__PURE__*/ $42omo.createElement((0, $dfe1275874cc34dc$export$2d2b754ac238f9aa), {
        message: message,
        testId: testId
    }));
    return /*#__PURE__*/ $42omo.createElement("div", {
        ref: blockRef,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ])
    }, actions, /*#__PURE__*/ $42omo.createElement((0, $dfe1275874cc34dc$export$2d2b754ac238f9aa), {
        message: message,
        testId: testId
    }));
};
var $018f38f6aa2eb81b$export$2e2bcd8739ae039 = $018f38f6aa2eb81b$var$ActionBlock;
module.exports["default"] = $018f38f6aa2eb81b$export$2e2bcd8739ae039;

});

parcelRegister("hpUsb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ggbZE = parcelRequire("ggbZE");

var $1DWH0 = parcelRequire("1DWH0");


var $lgqac = parcelRequire("lgqac");





var $lAJUP = parcelRequire("lAJUP");


var $fBMbo = parcelRequire("fBMbo");


var $dQl1W = parcelRequire("dQl1W");


var $kKODE = parcelRequire("kKODE");


var $bIll3 = parcelRequire("bIll3");


var $ivUmx = parcelRequire("ivUmx");


var $5MkWK = parcelRequire("5MkWK");


var $9E8aG = parcelRequire("9E8aG");


var $l6tPN = parcelRequire("l6tPN");


var $5Tie7 = parcelRequire("5Tie7");


const $494a9ab126f82b16$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $42omo.lazy)(()=>(0, $ivUmx.importWithRetry)(()=>(parcelRequire("1FwCa"))));
function $494a9ab126f82b16$export$e00a7788e30dc998(props) {
    (0, $fBMbo.di)($494a9ab126f82b16$export$a7690c318cd6a95e);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $l6tPN.clearMarks)(id);
            (0, $l6tPN.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, disablePreviewPanel: disablePreviewPanel } = props;
    const isFlexibleUi = (0, $9E8aG.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $5MkWK.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $42omo.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $bIll3.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $bIll3.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $bIll3.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FallbackComponent, null);
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt,
        disablePreviewPanel: disablePreviewPanel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tie7.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($494a9ab126f82b16$export$a7690c318cd6a95e, cardWithUrlProps, children)));
}


class $b7b2971f0774cd45$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $494a9ab126f82b16$export$e00a7788e30dc998), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            locale: "en"
        }, content);
    }
}
const $b7b2971f0774cd45$export$60332b2344f7fe41 = (0, $ggbZE.default)((0, $lgqac.context))((0, $1DWH0.default)()((0, $aXWIB.injectIntl)($b7b2971f0774cd45$var$PlainCard, {
    enforceContext: false
})));
module.exports["Card"] = $b7b2971f0774cd45$export$60332b2344f7fe41;

});

parcelRegister("5Tie7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1KuCI = parcelRequire("1KuCI");


var $9snKo = parcelRequire("9snKo");

const $eeea3d3a1c12cf78$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1KuCI.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9snKo.loadingPlaceholderClassName),
        placeholder: placeholder
    });
};
module.exports["LoadingCardLink"] = $eeea3d3a1c12cf78$export$1ca0544321134ad6;

});

parcelRegister("1KuCI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ioVck = parcelRequire("ioVck");

class $33c97c3cf1ea6f6c$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}
module.exports["CardLinkView"] = $33c97c3cf1ea6f6c$export$ce508304ed2dd145;

});

parcelRegister("ioVck", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4gM1A = parcelRequire("4gM1A");

/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");




const $f88a24196e637c23$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: _isInteractive, isSelected: isSelected, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: ref,
        ...props,
        className: (0, $gMc0m.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ])
    }, props.children);
});
const $f88a24196e637c23$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $42omo.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $gMc0m.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehiw5lj _1j5pglyw _1di615s3",
            viewType === 'errored' && "_4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
        ])
    }, props.children);
});
const $f88a24196e637c23$var$baseWrapperStyles = null; // if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $f88a24196e637c23$var$interactiveStyles = null;
const $f88a24196e637c23$var$hoveredStyles = null;
const $f88a24196e637c23$var$hoveredWithBackgroundStyles = null;
const $f88a24196e637c23$var$errorViewTypeStyles = null;
const $f88a24196e637c23$var$withoutBackgroundStyles = null;
const $f88a24196e637c23$var$withBackgroundStyles = null;
const $f88a24196e637c23$var$truncateStyles = null;
const $f88a24196e637c23$var$unauthorisedTruncateStyles = null;
const $f88a24196e637c23$var$notSelectedStyle = null;
const $f88a24196e637c23$var$selectedStyles = null;


const $0a9218124e4addff$export$b89a827e9254211a = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, link: link, viewType: viewType, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $42omo.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $42omo.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $f88a24196e637c23$export$6e4bde711df5c2ab) : (0, $f88a24196e637c23$export$8b5c95e985c4ec9a);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive && ((0, $dh538.fg)('navx-3611-inline-card-a11y-role-fix') ? !link : true) ? 0 : undefined,
        role: isInteractive && ((0, $dh538.fg)('navx-3611-inline-card-a11y-role-fix') ? !link : true) ? 'button' : undefined,
        onClick: handleClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        viewType: viewType
    }, children);
});
module.exports["Frame"] = $0a9218124e4addff$export$b89a827e9254211a;

});

parcelRegister("9snKo", function(module, exports) {
const $20ef05bed4af1360$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';
module.exports["loadingPlaceholderClassName"] = $20ef05bed4af1360$export$4b2b7d155f69aed4;

});

parcelRegister("1FwCa", function(module, exports) {

let $1372eb57b85865af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1372eb57b85865af$var$load("cSvhH"),
    $1372eb57b85865af$var$load("etEYy"),
    $1372eb57b85865af$var$load("93EyF"),
    $1372eb57b85865af$var$load("6EuUL"),
    $1372eb57b85865af$var$load("5ksq8"),
    $1372eb57b85865af$var$load("3BYXV"),
    $1372eb57b85865af$var$load("c251E"),
    $1372eb57b85865af$var$load("fx7pC"),
    $1372eb57b85865af$var$load("avPjX"),
    $1372eb57b85865af$var$load("gFEtJ"),
    $1372eb57b85865af$var$load("7jSfd"),
    $1372eb57b85865af$var$load("4HZlX"),
    $1372eb57b85865af$var$load("kDqHr"),
    $1372eb57b85865af$var$load("gT8XU"),
    $1372eb57b85865af$var$load("3GuOt"),
    $1372eb57b85865af$var$load("8l20h"),
    $1372eb57b85865af$var$load("9aQIt"),
    $1372eb57b85865af$var$load("XZauT"),
    $1372eb57b85865af$var$load("4S1SF"),
    $1372eb57b85865af$var$load("lm9Lt"),
    $1372eb57b85865af$var$load("9wPDc"),
    $1372eb57b85865af$var$load("1MWOL"),
    $1372eb57b85865af$var$load("6fQco"),
    $1372eb57b85865af$var$load("aOY32"),
    $1372eb57b85865af$var$load("3MYQs"),
    $1372eb57b85865af$var$load("6SWFK"),
    $1372eb57b85865af$var$load("5zapo"),
    $1372eb57b85865af$var$load("jiFtb"),
    $1372eb57b85865af$var$load("9atVd"),
    $1372eb57b85865af$var$load("iivLa"),
    $1372eb57b85865af$var$load("6wr18"),
    $1372eb57b85865af$var$load("dek7I"),
    $1372eb57b85865af$var$load("6iz6l"),
    $1372eb57b85865af$var$load("4SCW2"),
    $1372eb57b85865af$var$load("fdKpi"),
    $1372eb57b85865af$var$load("ffEVr"),
    $1372eb57b85865af$var$load("hhss7"),
    $1372eb57b85865af$var$load("l22f4"),
    $1372eb57b85865af$var$load("eTYdV"),
    $1372eb57b85865af$var$load("Wowvf"),
    $1372eb57b85865af$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("b16ZX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $5b6166ad5dd66d6f$var$TeamMemberCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT ? `${$5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).TeamMemberCount
    }) : null;
};
var $5b6166ad5dd66d6f$export$2e2bcd8739ae039 = $5b6166ad5dd66d6f$var$TeamMemberCountElement;
module.exports["default"] = $5b6166ad5dd66d6f$export$2e2bcd8739ae039;

});

parcelRegister("bG0uM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $abfd64423c5a2d62$var$UserAttributesElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
                    key: key,
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $5TXU5.ElementName).UserAttributes
                }));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, elements) : null;
};
var $abfd64423c5a2d62$export$2e2bcd8739ae039 = $abfd64423c5a2d62$var$UserAttributesElement;
module.exports["default"] = $abfd64423c5a2d62$export$2e2bcd8739ae039;

});

parcelRegister("8OVDp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $34076fdcb2e684ce$var$HostNameElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const hostName = context?.data?.hostName;
    return hostName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        content: hostName,
        ...props,
        name: (0, $5TXU5.ElementName).HostName
    }) : null;
};
var $34076fdcb2e684ce$export$2e2bcd8739ae039 = $34076fdcb2e684ce$var$HostNameElement;
module.exports["default"] = $34076fdcb2e684ce$export$2e2bcd8739ae039;

});

parcelRegister("e4NSt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $97e7d5657b08cc85$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $afp1H.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Component,
        label: label,
        ...props
    });
};
var $97e7d5657b08cc85$export$2e2bcd8739ae039 = $97e7d5657b08cc85$var$AppliedToComponentsCountElement;
module.exports["default"] = $97e7d5657b08cc85$export$2e2bcd8739ae039;

});

parcelRegister("4SEPT", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $1dfde747276dc37b$var$baseStyle = null;
const $1dfde747276dc37b$var$isMessageDescriptor = (x)=>!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(x);
const $1dfde747276dc37b$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $1dfde747276dc37b$var$maxLinesCss = null;
const $1dfde747276dc37b$var$CustomElementByAccessType = ({ className: className, testId: testId = 'custom-by-access-type-element', ...props })=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const contentForAccessType = props[accessType] ?? props.fallback;
    if (!contentForAccessType) return null;
    const values = context?.data?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction]?.values;
    if ($1dfde747276dc37b$var$isMessageDescriptor(contentForAccessType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...props,
        message: {
            descriptor: contentForAccessType,
            values: values
        },
        className: className,
        testId: testId,
        hideFormat: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            color: props.color
        },
        "data-separator": true,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            props.fontSize !== undefined && $1dfde747276dc37b$var$fontOverrideStyleMap[props.fontSize],
            "_1yyjkb7n _102k1j6v",
            className
        ])
    }, contentForAccessType);
};
var $1dfde747276dc37b$export$2e2bcd8739ae039 = $1dfde747276dc37b$var$CustomElementByAccessType;
module.exports["default"] = $1dfde747276dc37b$export$2e2bcd8739ae039;

});

parcelRegister("lOpcG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fUfR2 = parcelRequire("fUfR2");

const $0ea0c23a597f730f$var$CustomByStatusElement = ({ className: className, testId: testId = 'custom-by-status-element', ...props })=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-separator": true,
        "data-smart-element": "custom-element",
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, component);
};
var $0ea0c23a597f730f$export$2e2bcd8739ae039 = $0ea0c23a597f730f$var$CustomByStatusElement;
module.exports["default"] = $0ea0c23a597f730f$export$2e2bcd8739ae039;

});

parcelRegister("hJgLA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4wH3g = parcelRequire("4wH3g");


var $5TXU5 = parcelRequire("5TXU5");

const $ecdac2a9be051ad6$export$9d642f65a919fb93 = {
    [(0, $5TXU5.SmartLinkSize).Small]: 'none',
    [(0, $5TXU5.SmartLinkSize).Medium]: 'compact',
    [(0, $5TXU5.SmartLinkSize).Large]: 'compact',
    [(0, $5TXU5.SmartLinkSize).XLarge]: 'default'
};
const $ecdac2a9be051ad6$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...descriptor,
            values: values
        });
    }
};
const $ecdac2a9be051ad6$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $ecdac2a9be051ad6$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $ecdac2a9be051ad6$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "tmnOu",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $ecdac2a9be051ad6$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 1.75;
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $ecdac2a9be051ad6$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $ecdac2a9be051ad6$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5TXU5.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $ecdac2a9be051ad6$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};
module.exports["sizeToButtonSpacing"] = $ecdac2a9be051ad6$export$9d642f65a919fb93;
module.exports["getFormattedMessage"] = $ecdac2a9be051ad6$export$f1aa79f2218fb713;
module.exports["getFormattedMessageAsString"] = $ecdac2a9be051ad6$export$66ecb50a9dd1768;
module.exports["getIconWidth"] = $ecdac2a9be051ad6$export$fb10bc5609c6347e;
module.exports["importIcon"] = $ecdac2a9be051ad6$export$6dc831e1a0a7a851;
module.exports["getMaxLines"] = $ecdac2a9be051ad6$export$c2293adf1794c09;
module.exports["getPrimitivesInlineSpaceBySize"] = $ecdac2a9be051ad6$export$475c391af8171fec;
module.exports["hasWhiteSpace"] = $ecdac2a9be051ad6$export$619e376a425cb759;

});

parcelRegister("jLXEH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hmuev = parcelRequire("hmuev");


var $afp1H = parcelRequire("afp1H");


var $6FZ6a = parcelRequire("6FZ6a");

const $f415990ae4e7261e$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).delete),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).delete),
        ...props
    });
var $f415990ae4e7261e$export$2e2bcd8739ae039 = $f415990ae4e7261e$var$DeleteAction;
module.exports["default"] = $f415990ae4e7261e$export$2e2bcd8739ae039;

});

parcelRegister("dVBHR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Zr9M = parcelRequire("1Zr9M");


var $afp1H = parcelRequire("afp1H");


var $6FZ6a = parcelRequire("6FZ6a");

const $a74c68e5cf0852d5$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).edit),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).edit),
        ...props
    });
var $a74c68e5cf0852d5$export$2e2bcd8739ae039 = $a74c68e5cf0852d5$var$EditAction;
module.exports["default"] = $a74c68e5cf0852d5$export$2e2bcd8739ae039;

});

parcelRegister("fl0WE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");





var $fBMbo = parcelRequire("fBMbo");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $6KV13 = parcelRequire("6KV13");





var $aXWIB = parcelRequire("aXWIB");


var $gNXND = parcelRequire("gNXND");


var $3Mg7y = parcelRequire("3Mg7y");








var $kKODE = parcelRequire("kKODE");


var $afp1H = parcelRequire("afp1H");


var $k9nkv = parcelRequire("k9nkv");


var $6FZ6a = parcelRequire("6FZ6a");








var $kbh18 = parcelRequire("kbh18");







const $9dd168d53d6086c0$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $9dd168d53d6086c0$export$2e2bcd8739ae039 = $9dd168d53d6086c0$var$AIEventErrorViewed;






var $2Nwuj = parcelRequire("2Nwuj");







const $287ebec1fdd40e02$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: (0, $dh538.fg)('platform_sl_ai_summary_rebrand') ? (0, $5TXU5.CONTENT_URL_ROVO) : (0, $5TXU5.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $287ebec1fdd40e02$export$2e2bcd8739ae039 = $287ebec1fdd40e02$var$AILearnMoreAnchor;


const $b750d65dda1a4c8d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $kbh18.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9dd168d53d6086c0$export$2e2bcd8739ae039), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $287ebec1fdd40e02$export$2e2bcd8739ae039), {
                        href: url
                    }, chunks)
            }
        }))
    };
};


function $276cdae1a40ee2d2$export$75a19de44af58722({ onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const isRovoBlockCardExperimentEnabled = (0, $k9nkv.useBlockCardRovoActionExperimentNoExposure)();
    const onCompleted = (0, $42omo.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $b750d65dda1a4c8d$export$82f46aa4e6535a45)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    const Icon = (0, $dh538.fg)('platform_sl_ai_summary_rebrand') ? (0, (/*@__PURE__*/$parcel$interopDefault($gNXND))) : (0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $dh538.fg)('platform_sl_ai_summary_rebrand') ? (0, $afp1H.messages).ai_summary_action_rebrand : (0, $afp1H.messages).ai_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || isRovoBlockCardExperimentEnabled || (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) ? {
                size: props.iconSize
            } : {}
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $dh538.fg)('platform_sl_ai_summary_rebrand') ? (0, $afp1H.messages).ai_summary_action_description_rebrand : (0, $afp1H.messages).ai_summary_action_description),
        ...props
    });
}









var $2MuFw = parcelRequire("2MuFw");










function $8b66580330514e65$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $42omo.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $afp1H.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_summary_action_description),
        ...props
    });
}
function $8b66580330514e65$export$7e8c7a0de1a37bfe({ url: url, onClick: onClickCallback, summary: summary = '', testId: testId, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $42omo.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(summary);
        setTooltipMessage((0, $afp1H.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        summary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary",
            size: props.iconSize
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_summary_action_description),
        ...props
    });
}


const $b80129153fa85400$export$8eed96bc6d982595 = (props)=>{
    (0, $fBMbo.di)((0, $6KV13.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $6KV13.default)(url);
    (0, $42omo.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b66580330514e65$export$7e8c7a0de1a37bfe), {
        ...props,
        summary: content,
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b66580330514e65$export$cfa1d3eed9a61059), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $276cdae1a40ee2d2$export$75a19de44af58722), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};


const $773427e96b58aed9$var$AISummaryAction = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b80129153fa85400$export$8eed96bc6d982595), {
        ...actionData,
        ...props
    }) : null;
};
var $773427e96b58aed9$export$2e2bcd8739ae039 = $773427e96b58aed9$var$AISummaryAction;
module.exports["default"] = $773427e96b58aed9$export$2e2bcd8739ae039;

});

parcelRegister("loGLq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fxBfz = parcelRequire("fxBfz");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $dZ8uq = parcelRequire("dZ8uq");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $k9nkv = parcelRequire("k9nkv");


var $3eMTN = parcelRequire("3eMTN");


var $6FZ6a = parcelRequire("6FZ6a");




const $916427ca86a2c806$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $afp1H.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $afp1H.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};



const $12d115b9ed847307$var$AutomationModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f0sMY")));
const $12d115b9ed847307$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5TXU5.ActionName).AutomationAction];
    const isRovoBlockCardExperimentEnabled = (0, $k9nkv.useBlockCardRovoActionExperimentNoExposure)();
    const automationActionOnClick = (0, $42omo.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $916427ca86a2c806$export$93e707b363eaf5c8)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        as: "strong"
                    }, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12d115b9ed847307$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $afp1H.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
            spacing: "spacious",
            color: "currentColor",
            label: automationActionIconLabel,
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || isRovoBlockCardExperimentEnabled || (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) ? {
                size: props.iconSize
            } : {}
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $12d115b9ed847307$export$2e2bcd8739ae039 = $12d115b9ed847307$var$AutomationAction;
module.exports["default"] = $12d115b9ed847307$export$2e2bcd8739ae039;

});

parcelRegister("9Gqdx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $kKODE = parcelRequire("kKODE");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $3eMTN = parcelRequire("3eMTN");


var $6FZ6a = parcelRequire("6FZ6a");





var $kevJM = parcelRequire("kevJM");




const $c0b0240da4db21c1$var$RelatedLinksActionIcon = ({ iconSize: iconSize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
        color: "currentColor",
        spacing: "spacious",
        label: (0, $dh538.fg)('navx-3698-flexible-card-a11y-fix') ? '' : 'View related links...',
        size: iconSize
    });
var $c0b0240da4db21c1$export$2e2bcd8739ae039 = $c0b0240da4db21c1$var$RelatedLinksActionIcon;



const $c0c15e76cd694fe8$var$RelatedLinksModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aEcBF")));
const $c0c15e76cd694fe8$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const onClick = (0, $42omo.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c0c15e76cd694fe8$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).related_links_view_related_links),
        ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) ? {
            tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).related_links_view_related_links)
        } : {},
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c0b0240da4db21c1$export$2e2bcd8739ae039), (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || (0, $dZ8uq.expValEqualsNoExposure)('rovogrowth-640-inline-action-nudge-exp', 'isEnabled', true) ? {
            iconSize: props.iconSize
        } : {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $c0c15e76cd694fe8$export$2e2bcd8739ae039 = $c0c15e76cd694fe8$var$ViewRelatedLinksAction;
module.exports["default"] = $c0c15e76cd694fe8$export$2e2bcd8739ae039;

});

parcelRegister("j5Rp4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

const $fd2ed04371a16208$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $fd2ed04371a16208$var$validErrorStatuses = [
    (0, $5TXU5.SmartLinkStatus).Forbidden,
    (0, $5TXU5.SmartLinkStatus).Unauthorized
];
const $fd2ed04371a16208$var$validateErrorStatus = (status)=>{
    return status !== undefined && $fd2ed04371a16208$var$validErrorStatuses.includes(status);
};
const $fd2ed04371a16208$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$fd2ed04371a16208$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
};
const $fd2ed04371a16208$var$CustomUnresolvedAction = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $fd2ed04371a16208$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $fd2ed04371a16208$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...messageDescriptor,
        values: values
    }));
    const component = hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $fd2ed04371a16208$var$styles.button
    }, message) : message;
    return Container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Container, null, component) : component;
};
var $fd2ed04371a16208$export$2e2bcd8739ae039 = $fd2ed04371a16208$var$CustomUnresolvedAction;
module.exports["default"] = $fd2ed04371a16208$export$2e2bcd8739ae039;

});

parcelRegister("dz3R2", function(module, exports) {
const $57620134bc940971$export$61874183278c256e = [
    'JSM',
    'JWM',
    'JSW',
    'JPD'
];
module.exports["JIRA_PRODUCTS"] = $57620134bc940971$export$61874183278c256e;

});

parcelRegister("1iDg7", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $8ddce3b50e63e6e3$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $42omo.useRef)(null);
        (0, $42omo.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            ref: ref
        });
    };
}
module.exports["withOverrideCss"] = $8ddce3b50e63e6e3$export$e0bdcacb944f1da6;

});

parcelRegister("2gWqY", function(module, exports) {
$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("6cbph")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("4wLtQ")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("iNImz")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("LrBxG")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("bWsCB")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("azCqP")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("kexiH")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("e8W8a")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("3nul2")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("jKoRo")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("bmx11")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("jI5eg")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("8iOdP")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("jW9GW")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("1WqHG")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("ful5o")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("41AV3")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("ikM9T")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("8YJtM")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("6Ed8U")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("2ZgNz")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("iuEuh")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("2GDee")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("h2WFd")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("49WiA")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("aGsNO")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("emfmd")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("a0Yyn")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("b8mrt")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("jpKes")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("hIbqn")).default);
$parcel$export(module.exports, "TeamMemberCount", () => (parcelRequire("b16ZX")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("gHW9t")).default);
$parcel$export(module.exports, "UserAttributes", () => (parcelRequire("bG0uM")).default);
$parcel$export(module.exports, "HostName", () => (parcelRequire("8OVDp")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("zH0mb")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("6LJqp")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("e4NSt")).default);
$parcel$export(module.exports, "CustomByAccessTypeElement", () => (parcelRequire("4SEPT")).default);
$parcel$export(module.exports, "CustomByStatusElement", () => (parcelRequire("lOpcG")).default);

var $6cbph = parcelRequire("6cbph");


var $4wLtQ = parcelRequire("4wLtQ");


var $iNImz = parcelRequire("iNImz");


var $LrBxG = parcelRequire("LrBxG");


var $bWsCB = parcelRequire("bWsCB");


var $azCqP = parcelRequire("azCqP");


var $kexiH = parcelRequire("kexiH");


var $e8W8a = parcelRequire("e8W8a");


var $3nul2 = parcelRequire("3nul2");


var $jKoRo = parcelRequire("jKoRo");


var $bmx11 = parcelRequire("bmx11");


var $jI5eg = parcelRequire("jI5eg");


var $8iOdP = parcelRequire("8iOdP");


var $jW9GW = parcelRequire("jW9GW");


var $1WqHG = parcelRequire("1WqHG");


var $ful5o = parcelRequire("ful5o");


var $41AV3 = parcelRequire("41AV3");


var $ikM9T = parcelRequire("ikM9T");


var $8YJtM = parcelRequire("8YJtM");


var $6Ed8U = parcelRequire("6Ed8U");


var $2ZgNz = parcelRequire("2ZgNz");


var $iuEuh = parcelRequire("iuEuh");


var $2GDee = parcelRequire("2GDee");


var $h2WFd = parcelRequire("h2WFd");


var $49WiA = parcelRequire("49WiA");


var $aGsNO = parcelRequire("aGsNO");


var $emfmd = parcelRequire("emfmd");


var $a0Yyn = parcelRequire("a0Yyn");


var $b8mrt = parcelRequire("b8mrt");


var $jpKes = parcelRequire("jpKes");


var $hIbqn = parcelRequire("hIbqn");


var $b16ZX = parcelRequire("b16ZX");


var $gHW9t = parcelRequire("gHW9t");


var $bG0uM = parcelRequire("bG0uM");


var $8OVDp = parcelRequire("8OVDp");


var $zH0mb = parcelRequire("zH0mb");


var $6LJqp = parcelRequire("6LJqp");


var $e4NSt = parcelRequire("e4NSt");


var $4SEPT = parcelRequire("4SEPT");


var $lOpcG = parcelRequire("lOpcG");


});

parcelRegister("9AUBM", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $k9nkv = parcelRequire("k9nkv");


var $b6b6P = parcelRequire("b6b6P");


var $iFRRf = parcelRequire("iFRRf");


var $1iDg7 = parcelRequire("1iDg7");


var $hJgLA = parcelRequire("hJgLA");

const $951dc084d4c33fc9$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c8wadc"
};
const $951dc084d4c33fc9$var$colorMap = {
    subtle: "_syaz1rpy",
    default: "_syazazsu"
};
const $951dc084d4c33fc9$var$messageMapper = {
    [(0, $5TXU5.IconType).PriorityBlocker]: (0, $afp1H.messages).priority_blocker,
    [(0, $5TXU5.IconType).PriorityCritical]: (0, $afp1H.messages).priority_critical,
    [(0, $5TXU5.IconType).PriorityHigh]: (0, $afp1H.messages).priority_high,
    [(0, $5TXU5.IconType).PriorityHighest]: (0, $afp1H.messages).priority_highest,
    [(0, $5TXU5.IconType).PriorityLow]: (0, $afp1H.messages).priority_low,
    [(0, $5TXU5.IconType).PriorityLowest]: (0, $afp1H.messages).priority_lowest,
    [(0, $5TXU5.IconType).PriorityMajor]: (0, $afp1H.messages).priority_major,
    [(0, $5TXU5.IconType).PriorityMedium]: (0, $afp1H.messages).priority_medium,
    [(0, $5TXU5.IconType).PriorityMinor]: (0, $afp1H.messages).priority_minor,
    [(0, $5TXU5.IconType).PriorityTrivial]: (0, $afp1H.messages).priority_trivial,
    [(0, $5TXU5.IconType).PriorityUndefined]: (0, $afp1H.messages).priority_undefined
};
const $951dc084d4c33fc9$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $951dc084d4c33fc9$var$messageMapper[icon];
        if (descriptor) return (0, $hJgLA.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $951dc084d4c33fc9$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iFRRf.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $951dc084d4c33fc9$var$renderImageIcon = (url, testId, hideLoadingSkeleton)=>{
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b6b6P.default), {
        testId: testId,
        url: url,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $951dc084d4c33fc9$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color, hideLabel: hideLabel = false }, ref)=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const isRovoBlockCardExperimentEnabled = (0, $k9nkv.useBlockCardRovoActionExperimentNoExposure)();
    const formattedMessageOrLabel = $951dc084d4c33fc9$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $951dc084d4c33fc9$var$renderAtlaskitIcon(icon, testId) || $951dc084d4c33fc9$var$renderImageIcon(url, testId, ui?.hideLoadingSkeleton);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    const shouldHideLabel = hideLabel && isRovoBlockCardExperimentEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $gMc0m.default)([
            $951dc084d4c33fc9$var$styles.container,
            $951dc084d4c33fc9$var$colorMap[appearance]
        ])
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $951dc084d4c33fc9$var$styles.icon
    }, badgeIcon), !shouldHideLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        testId: `${testId}-label`,
        xcss: $951dc084d4c33fc9$var$styles.text
    }, formattedMessageOrLabel));
});
const $951dc084d4c33fc9$var$_default_1 = (0, $1iDg7.withOverrideCss)($951dc084d4c33fc9$var$BaseBadgeRefreshNew);
var $951dc084d4c33fc9$export$2e2bcd8739ae039 = $951dc084d4c33fc9$var$_default_1;
const $951dc084d4c33fc9$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};
module.exports["default"] = $951dc084d4c33fc9$export$2e2bcd8739ae039;
module.exports["toBadgeProps"] = $951dc084d4c33fc9$export$a2fb457791942ba4;

});

parcelRegister("9mMJ0", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2Pg7f = parcelRequire("2Pg7f");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $hJgLA = parcelRequire("hJgLA");

const $9a89fd087e8e9b91$var$styles = null;
const $9a89fd087e8e9b91$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5TXU5.ElementName).AssignedToGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).assigned_to, personName);
        case (0, $5TXU5.ElementName).OwnedByGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).owned_by, personName);
        case (0, $5TXU5.ElementName).AuthorGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).created_by, personName);
        default:
            return personName;
    }
};
const $9a89fd087e8e9b91$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $aXWIB.useIntl)();
    const data = (0, $42omo.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5TXU5.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
         //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $9a89fd087e8e9b91$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ $42omo.createElement("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    , {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2Pg7f.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $9a89fd087e8e9b91$export$2e2bcd8739ae039 = $9a89fd087e8e9b91$var$BaseAvatarGroup;
const $9a89fd087e8e9b91$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
module.exports["default"] = $9a89fd087e8e9b91$export$2e2bcd8739ae039;
module.exports["toAvatarGroupProps"] = $9a89fd087e8e9b91$export$91ba8651475968bd;

});

parcelRegister("iFRRf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $7642E = parcelRequire("7642E");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $7CgcZ = parcelRequire("7CgcZ");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");

const $536366acab81aece$var$getIconImportFn = (icon, size)=>{
    const item = (0, $ivUmx.getLazyIcons)()[icon];
    if ((0, $ivUmx.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $536366acab81aece$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "rynap",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};

const $536366acab81aece$var$getBlogIcon = ()=>(parcelRequire("7r4Rz")).default;

const $536366acab81aece$var$getDocumentIcon = ()=>(parcelRequire("9SMct")).default;

const $536366acab81aece$var$getLiveDocumentIcon = ()=>(parcelRequire("GFtWS")).default;
const $536366acab81aece$var$isCoreIcon = (icon)=>{
    return [
        (0, $5TXU5.IconType).Project,
        (0, $5TXU5.IconType).Template,
        (0, $5TXU5.IconType).Forbidden,
        (0, $5TXU5.IconType).Default,
        (0, $5TXU5.IconType).Error,
        (0, $5TXU5.IconType).Attachment,
        (0, $5TXU5.IconType).CheckItem,
        (0, $5TXU5.IconType).Component,
        (0, $5TXU5.IconType).Comment,
        (0, $5TXU5.IconType).View,
        (0, $5TXU5.IconType).React,
        (0, $5TXU5.IconType).Vote,
        (0, $5TXU5.IconType).PriorityUndefined,
        (0, $5TXU5.IconType).ProgrammingLanguage,
        (0, $5TXU5.IconType).Subscriber,
        (0, $5TXU5.IconType).SubTasksProgress
    ].includes(icon);
};
const $536366acab81aece$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5TXU5.SmartLinkSize).Medium, isTiledIcon: isTiledIcon })=>{
    if (!(0, $dh538.fg)('platform_sl_icons_refactor')) // Check for synchronously loaded icons first for SSR purposes.
    // Require these icons only inside this branch to avoid evaluating legacy icon
    // wrapper modules when the icon refactor is enabled.
    switch(icon){
        case (0, $5TXU5.IconType).Document:
            {
                const DocumentIcon = $536366acab81aece$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DocumentIcon, {
                    label: label ?? 'document',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $5TXU5.IconType).Blog:
            {
                const BlogIcon = $536366acab81aece$var$getBlogIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BlogIcon, {
                    label: label ?? 'blog',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $5TXU5.IconType).LiveDocument:
            {
                const LiveDocumentIcon = $536366acab81aece$var$getLiveDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LiveDocumentIcon, {
                    label: label ?? 'live-doc',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
    }
    const importFn = $536366acab81aece$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $536366acab81aece$var$importIcon(importFn);
    if ($536366acab81aece$var$isCoreIcon(icon) && (0, $dh538.fg)('platform_sl_icons_refactor')) {
        let color;
        if (icon === (0, $5TXU5.IconType).Error || icon === (0, $5TXU5.IconType).Forbidden) color = "var(--ds-icon-danger, #C9372C)";
        switch(size){
            case (0, $5TXU5.SmartLinkSize).Small:
            case (0, $5TXU5.SmartLinkSize).Medium:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
            case (0, $5TXU5.SmartLinkSize).Large:
            case (0, $5TXU5.SmartLinkSize).XLarge:
                let appearance;
                if (icon === (0, $5TXU5.IconType).Error || icon === (0, $5TXU5.IconType).Forbidden) appearance = 'redBold';
                else appearance = 'grayBold';
                const iconTileSize = (0, $7CgcZ.transformSmartLinkSizeToIconTileSize)(size);
                if (iconTileSize) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
                    appearance: appearance,
                    icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                            ...iconProps,
                            spacing: "spacious"
                        }) : ImportedIcon,
                    size: iconTileSize,
                    label: label ?? ''
                });
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
        }
    }
    switch(icon){
        case (0, $5TXU5.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $5TXU5.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $5TXU5.IconType).Error:
        case (0, $5TXU5.IconType).Forbidden:
            if ((0, $dh538.fg)('platform_sl_icons_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
    }
};
var $536366acab81aece$export$2e2bcd8739ae039 = $536366acab81aece$var$AtlaskitIcon;
module.exports["default"] = $536366acab81aece$export$2e2bcd8739ae039;

});

parcelRegister("6wR2f", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4ULqR = parcelRequire("4ULqR");


var $aXWIB = parcelRequire("aXWIB");


var $afp1H = parcelRequire("afp1H");

const $bbe6fa3f8ea6e4e4$var$styles = null;
const $bbe6fa3f8ea6e4e4$var$typeToDescriptorMap = {
    created: {
        relative: (0, $afp1H.messages).created_on_relative,
        absolute: (0, $afp1H.messages).created_on_absolute
    },
    modified: {
        relative: (0, $afp1H.messages).modified_on_relative,
        absolute: (0, $afp1H.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $afp1H.messages).sent_on_relative,
        absolute: (0, $afp1H.messages).sent_on_absolute
    }
};
const $bbe6fa3f8ea6e4e4$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $bbe6fa3f8ea6e4e4$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $aXWIB.useIntl)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $4ULqR.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
        ...$bbe6fa3f8ea6e4e4$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ $42omo.createElement("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && $bbe6fa3f8ea6e4e4$var$fontOverrideStyleMap[fontSize],
            className
        ])
    }, content);
};
var $bbe6fa3f8ea6e4e4$export$2e2bcd8739ae039 = $bbe6fa3f8ea6e4e4$var$BaseDateTimeElement;
const $bbe6fa3f8ea6e4e4$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
module.exports["default"] = $bbe6fa3f8ea6e4e4$export$2e2bcd8739ae039;
module.exports["toDateTimeProps"] = $bbe6fa3f8ea6e4e4$export$2d4384e6b150cbe3;

});

parcelRegister("7f92O", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $ho4zm = parcelRequire("ho4zm");


var $fUfR2 = parcelRequire("fUfR2");


var $cS65x = parcelRequire("cS65x");

const $7edf4af2ffda473e$var$styles = null;
const $7edf4af2ffda473e$var$dueOnStyles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $7edf4af2ffda473e$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', className: className, maxWidth: maxWidth, name: name, onAfterChanged: onAfterChanged, style: style, text: text, testId: testId = 'smart-element-lozenge', isDateTag: isDateTag, trailingMetric: trailingMetric })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ $42omo.createElement((0, $cS65x.default), {
        action: action,
        appearance: appearance,
        maxWidth: maxWidth,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex,
        onAfterChanged: onAfterChanged,
        ...trailingMetric && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }) : isDateTag ? /*#__PURE__*/ $42omo.createElement((0, $ho4zm.default), {
        text: text,
        migration_fallback: "lozenge"
    }) : /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: true,
        maxWidth: maxWidth,
        style: style,
        testId: `${testId}-lozenge`,
        ...trailingMetric && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }, text);
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c116y _1ul91ns9",
            isDateTag && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr",
            className
        ])
    }, lozenge);
};
var $7edf4af2ffda473e$export$2e2bcd8739ae039 = $7edf4af2ffda473e$var$BaseLozengeElement;
const $7edf4af2ffda473e$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
module.exports["default"] = $7edf4af2ffda473e$export$2e2bcd8739ae039;
module.exports["toDateLozengeProps"] = $7edf4af2ffda473e$export$8f9f58f7bac50fbe;

});

parcelRegister("8bb8e", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $5TXU5 = parcelRequire("5TXU5");


var $4gM1A = parcelRequire("4gM1A");


var $hJgLA = parcelRequire("hJgLA");

const $eb4f16a03665d341$var$DEFAULT_MAX_LINES = 2;
const $eb4f16a03665d341$var$MAXIMUM_MAX_LINES = 2;
const $eb4f16a03665d341$var$MINIMUM_MAX_LINES = 1;
const $eb4f16a03665d341$var$containerStyles = null;
const $eb4f16a03665d341$var$getMaxLines = (maxLines)=>{
    if (maxLines > $eb4f16a03665d341$var$MAXIMUM_MAX_LINES) return $eb4f16a03665d341$var$DEFAULT_MAX_LINES;
    if (maxLines < $eb4f16a03665d341$var$MINIMUM_MAX_LINES) return $eb4f16a03665d341$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $eb4f16a03665d341$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
const $eb4f16a03665d341$var$linkStyleSizeMap = {
    xlarge: "_11c81af2 _k48pi7a9 _vwz41k8s",
    large: "_11c8fhey _k48pi7a9 _vwz41j6v",
    medium: "_11c8fhey _k48pi7a9 _vwz41j6v",
    small: "_11c8wadc _k48pi7a9 _vwz41j6v"
};
const $eb4f16a03665d341$var$baseAnchorStyle = null;
const $eb4f16a03665d341$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $eb4f16a03665d341$var$anchorConstantsStyles = null;
const $eb4f16a03665d341$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $eb4f16a03665d341$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $eb4f16a03665d341$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $eb4f16a03665d341$var$themeStyleMap = {
    grey: "_fjv61r31 _93u91r31 _g2lk1r31 _pnzf1r31 _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray1rpy _dlb71rpy _rnxt1rpy _1h4d1rpy _10uewadc _ye101rpy",
    black: "_syazazsu _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2wa8stv _4fpr8stv _1bnx8stv _1x288stv _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8hazsu _f8pjazsu _30l3azsu _1053azsu",
    link: "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
const $eb4f16a03665d341$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $eb4f16a03665d341$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5TXU5.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const hasSpace = (0, $42omo.useMemo)(()=>text ? (0, $hJgLA.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $eb4f16a03665d341$var$linkStyleSizeMap[size],
            $eb4f16a03665d341$var$anchorLineClampMap[$eb4f16a03665d341$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $eb4f16a03665d341$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $eb4f16a03665d341$var$getMaxLines(maxLines) === 1 && $eb4f16a03665d341$var$anchorLinkLineHeight1Map[size],
            $eb4f16a03665d341$var$getMaxLines(maxLines) === 2 && $eb4f16a03665d341$var$anchorLinkLineHeight2Map[size],
            $eb4f16a03665d341$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef
    }, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ])
    }, hideTooltip || text === undefined ? anchor : $eb4f16a03665d341$var$withTooltip(anchor, url?.includes(text) ? url : text, testId));
};
var $eb4f16a03665d341$export$2e2bcd8739ae039 = $eb4f16a03665d341$var$BaseLinkElement;
const $eb4f16a03665d341$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
module.exports["default"] = $eb4f16a03665d341$export$2e2bcd8739ae039;

});

parcelRegister("g98dH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $htjmD = parcelRequire("htjmD");


var $eIleF = parcelRequire("eIleF");

const $b01bbbcb1713fd75$var$useInvoke = ()=>{
    const { connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const clientExt = (0, $htjmD.useSmartLinkClientExtension)(connections.client);
    return (0, $42omo.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b01bbbcb1713fd75$export$2e2bcd8739ae039 = $b01bbbcb1713fd75$var$useInvoke;
module.exports["default"] = $b01bbbcb1713fd75$export$2e2bcd8739ae039;

});

parcelRegister("8i8ID", function(module, exports) {

var $lgqac = parcelRequire("lgqac");

const $e9aefac4b34acc2c$export$65b3f792dff0bd60 = (err)=>{
    if (!$e9aefac4b34acc2c$export$1694272377fa07d8(err)) return (0, $lgqac.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $lgqac.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $lgqac.TrackQuickActionFailureReason).UnknownError;
    }
};
const $e9aefac4b34acc2c$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;
module.exports["getInvokeFailureReason"] = $e9aefac4b34acc2c$export$65b3f792dff0bd60;
module.exports["isInvokeCustomError"] = $e9aefac4b34acc2c$export$1694272377fa07d8;

});

parcelRegister("jlQ9A", function(module, exports) {
$parcel$export(module.exports, "CustomAction", () => (parcelRequire("6FZ6a")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("jLXEH")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("dVBHR")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("cLh5D")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("9l03X")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("2vLbR")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("apOlf")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("lVA2Y")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("fl0WE")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("loGLq")).default);
$parcel$export(module.exports, "RovoChatAction", () => (parcelRequire("1MuZd")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("9Gqdx")).default);
$parcel$export(module.exports, "CustomUnresolvedAction", () => (parcelRequire("j5Rp4")).default);

var $6FZ6a = parcelRequire("6FZ6a");


var $jLXEH = parcelRequire("jLXEH");


var $dVBHR = parcelRequire("dVBHR");


var $cLh5D = parcelRequire("cLh5D");


var $9l03X = parcelRequire("9l03X");


var $2vLbR = parcelRequire("2vLbR");


var $apOlf = parcelRequire("apOlf");


var $lVA2Y = parcelRequire("lVA2Y");


var $fl0WE = parcelRequire("fl0WE");


var $loGLq = parcelRequire("loGLq");


var $1MuZd = parcelRequire("1MuZd");


var $9Gqdx = parcelRequire("9Gqdx");


var $j5Rp4 = parcelRequire("j5Rp4");


});

parcelRegister("6bBFP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $c30cfb4c0c886f9b$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $42omo.useState)(0);
    const ref = (0, $42omo.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $42omo.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
var $c30cfb4c0c886f9b$export$2e2bcd8739ae039 = $c30cfb4c0c886f9b$export$6118ed0013927eb2;
module.exports["default"] = $c30cfb4c0c886f9b$export$2e2bcd8739ae039;

});

parcelRegister("4ULqR", function(module, exports) {
var $39412f7225a31c87$var$__assign = undefined && undefined.__assign || function() {
    $39412f7225a31c87$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39412f7225a31c87$var$__assign.apply(this, arguments);
};
var $39412f7225a31c87$var$MS_PER_SECOND = 1e3;
var $39412f7225a31c87$var$SECS_PER_MIN = 60;
var $39412f7225a31c87$var$SECS_PER_HOUR = $39412f7225a31c87$var$SECS_PER_MIN * 60;
var $39412f7225a31c87$var$SECS_PER_DAY = $39412f7225a31c87$var$SECS_PER_HOUR * 24;
var $39412f7225a31c87$var$SECS_PER_WEEK = $39412f7225a31c87$var$SECS_PER_DAY * 7;
function $39412f7225a31c87$export$b8f7189986dd5395(from, to, thresholds) {
    if (to === void 0) to = Date.now();
    if (thresholds === void 0) thresholds = {};
    var resolvedThresholds = $39412f7225a31c87$var$__assign($39412f7225a31c87$var$__assign({}, $39412f7225a31c87$export$f4fd60e41371f80d), thresholds || {});
    var secs = (+from - +to) / $39412f7225a31c87$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    var mins = secs / $39412f7225a31c87$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    var hours = secs / $39412f7225a31c87$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    var days = secs / $39412f7225a31c87$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    var fromDate = new Date(from);
    var toDate = new Date(to);
    var years = fromDate.getFullYear() - toDate.getFullYear();
    if (Math.round(Math.abs(years)) > 0) return {
        value: Math.round(years),
        unit: 'year'
    };
    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
    if (Math.round(Math.abs(months)) > 0) return {
        value: Math.round(months),
        unit: 'month'
    };
    var weeks = secs / $39412f7225a31c87$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
var $39412f7225a31c87$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};
module.exports["selectUnit"] = $39412f7225a31c87$export$b8f7189986dd5395;

});

parcelRegister("cS65x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $52EPl = parcelRequire("52EPl");


var $dh538 = parcelRequire("dh538");


var $kKODE = parcelRequire("kKODE");


var $eJ92v = parcelRequire("eJ92v");


var $g98dH = parcelRequire("g98dH");


var $8i8ID = parcelRequire("8i8ID");


var $7DSoa = parcelRequire("7DSoa");


var $cOlaT = parcelRequire("cOlaT");


var $lgqac = parcelRequire("lgqac");


var $b7GIg = parcelRequire("b7GIg");


var $667Mo = parcelRequire("667Mo");


var $7uUCV = parcelRequire("7uUCV");


var $bTJCs = parcelRequire("bTJCs");


var $58trk = parcelRequire("58trk");


var $dXPIV = parcelRequire("dXPIV");

const $7fab12f071167d36$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $7fab12f071167d36$var$LozengeAction = ({ action: action, appearance: appearance, maxWidth: maxWidth, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex, onAfterChanged: onAfterChanged, trailingMetric: trailingMetric, shouldRenderToParent: shouldRenderToParent = false })=>{
    const [selected, setSelected] = (0, $42omo.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $42omo.useState)(false);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [items, setItems] = (0, $42omo.useState)();
    const [errorMessage, setErrorMessage] = (0, $42omo.useState)();
    const reload = (0, $7DSoa.default)();
    const invoke = (0, $g98dH.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $42omo.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $lgqac.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $eJ92v.default));
                const validItems = typeof text === 'string' ? $7fab12f071167d36$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $dh538.fg)('confluence-issue-terminology-refresh') ? (0, $bTJCs.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $bTJCs.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch  {
                setErrorMessage((0, $bTJCs.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dXPIV.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            maxWidth: maxWidth,
            testId: testId,
            text: selected.text,
            trailingMetric: trailingMetric
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        maxWidth,
        testId,
        trailingMetric
    ]);
    const handleItemClick = (0, $42omo.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $cOlaT.default)(updateAction, id);
                await invoke(request);
                onAfterChanged?.();
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $lgqac.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $8i8ID.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $bTJCs.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent,
        onAfterChanged
    ]);
    const dropdownItemGroup = (0, $42omo.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7uUCV.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58trk.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        shouldRenderToParent: shouldRenderToParent
    }, dropdownItemGroup);
};
const $7fab12f071167d36$var$_default_1 = (0, $b7GIg.default)($7fab12f071167d36$var$LozengeAction);
var $7fab12f071167d36$export$2e2bcd8739ae039 = $7fab12f071167d36$var$_default_1;
module.exports["default"] = $7fab12f071167d36$export$2e2bcd8739ae039;

});

parcelRegister("htjmD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gmi3X = parcelRequire("gmi3X");


var $4X6f2 = parcelRequire("4X6f2");


var $1Okf1 = parcelRequire("1Okf1");

const $6bb10922c4ae303f$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $1Okf1.useResolverUrl)(cardClient);
    const invoke = (0, $42omo.useCallback)(async (data)=>{
        try {
            return await (0, $gmi3X.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $4X6f2.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $42omo.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};
module.exports["useSmartLinkClientExtension"] = $6bb10922c4ae303f$export$303ede4eed148855;

});

parcelRegister("eJ92v", function(module, exports) {
const $de46c47a4ecd1eb4$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $de46c47a4ecd1eb4$export$2e2bcd8739ae039 = $de46c47a4ecd1eb4$var$extractLozengeActionItems;
module.exports["default"] = $de46c47a4ecd1eb4$export$2e2bcd8739ae039;

});

parcelRegister("cOlaT", function(module, exports) {
const $fa24a5eb3eb20317$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $fa24a5eb3eb20317$export$2e2bcd8739ae039 = $fa24a5eb3eb20317$var$createStatusUpdateRequest;
module.exports["default"] = $fa24a5eb3eb20317$export$2e2bcd8739ae039;

});

parcelRegister("b7GIg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $5nBzc = parcelRequire("5nBzc");

const $d9e0a5eb52a0a8a6$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
                appearance: props?.appearance,
                isBold: true,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                trailingMetric: props?.trailingMetric
            }, props?.text), [
            props?.appearance,
            props?.testId,
            props?.text,
            props?.trailingMetric
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props));
    };
var $d9e0a5eb52a0a8a6$export$2e2bcd8739ae039 = $d9e0a5eb52a0a8a6$var$withErrorBoundary;
module.exports["default"] = $d9e0a5eb52a0a8a6$export$2e2bcd8739ae039;

});

parcelRegister("667Mo", function(module, exports) {
const $e47eb447ef32ebf8$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $e47eb447ef32ebf8$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $e47eb447ef32ebf8$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $e47eb447ef32ebf8$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};
module.exports["unknownLoadErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$2a568ff99500df53;
module.exports["permissionLoadErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$2de2d0ccc17b915f;
module.exports["unknownUpdateErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$c1c05f9d51f7c467;
module.exports["validationUpdateErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$618660b8f2aa87e2;

});

parcelRegister("7uUCV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $aXWIB = parcelRequire("aXWIB");


var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $a3fRD = parcelRequire("a3fRD");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $kKODE = parcelRequire("kKODE");


var $afp1H = parcelRequire("afp1H");


var $9oOnT = parcelRequire("9oOnT");


var $hJgLA = parcelRequire("hJgLA");

const $86481dd22f22993b$var$MAX_LINE_NUMBER = 8;
const $86481dd22f22993b$var$styles = {
    contentStyles: "_zulpu2gc _11c81d4k _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqmefhey _102efhey _ngc0i7uo _1t4pi7uo",
    linkStyles: "_zulpu2gc _1reo15vq _18m915vq _11c8fhey _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o",
    textStylesBase: "_11c81d4k _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
    dropdownItemGroupStyles: "_14hp1wdt _6pup1kw7 _1eo073ad",
    openIssueInJiraStyles: "_11c8fhey _bfhk1j28 _1bah1e5h _1e0c1kw7 _syaz13af _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l312zz"
};
const $86481dd22f22993b$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $86481dd22f22993b$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const invoke = (0, $9oOnT.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $42omo.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $86481dd22f22993b$var$styles.contentStyles
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
            testId: `${testId}-icon`,
            color: "var(--ds-icon-danger, #C9372C)",
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": `${testId}-error-message`,
            className: (0, $gMc0m.default)([
                $86481dd22f22993b$var$styles.textStylesBase,
                "_1yyj1n6p _102k16q4"
            ]),
            style: {
                "--_t4prqe": (0, $7sObp.default)(maxLineNumber)
            }
        }, typeof errorMessage === 'string' ? errorMessage : (0, $hJgLA.getFormattedMessage)(errorMessage))), isPreviewAvailable ? /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $86481dd22f22993b$var$styles.linkStyles
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
            testId: `${testId}-open-embed`,
            onClick: handlePreviewOpen,
            xcss: $86481dd22f22993b$var$styles.openIssueInJiraStyles
        }, (0, $dh538.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).open_issue_in_jiraIssueTermRefresh) : /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $gMc0m.default)([
            $86481dd22f22993b$var$styles.dropdownItemGroupStyles
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), null, /*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
        testId: `${testId}-error`
    }, content)));
};
var $86481dd22f22993b$export$2e2bcd8739ae039 = $86481dd22f22993b$var$LozengeActionError;
module.exports["default"] = $86481dd22f22993b$export$2e2bcd8739ae039;

});

parcelRegister("bTJCs", function(module, exports) {

var $afp1H = parcelRequire("afp1H");

const $3b4344c10bfc2ba3$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $afp1H.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $afp1H.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $afp1H.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $afp1H.messages)['status_change_update_error']
    }
};
module.exports["LozengeActionErrorMessages"] = $3b4344c10bfc2ba3$export$4f2e371a667ad688;

});

parcelRegister("58trk", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ahaN7 = parcelRequire("ahaN7");


var $k5ktp = parcelRequire("k5ktp");

const $7734c527fca28b11$var$dropdownItemGroupStyles = null;
const $7734c527fca28b11$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $gMc0m.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll71dpa _qprf1dpa _n6y8usvi _109gusvi _z29h1x9r _wlxp1x9r _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), null, items.map((item, idx)=>/*#__PURE__*/ $42omo.createElement((0, $k5ktp.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $7734c527fca28b11$export$2e2bcd8739ae039 = $7734c527fca28b11$var$LozengeActionItemsGroup;
module.exports["default"] = $7734c527fca28b11$export$2e2bcd8739ae039;

});

parcelRegister("dXPIV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $5nBzc = parcelRequire("5nBzc");

var $9E7O8 = parcelRequire("9E7O8");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $afp1H = parcelRequire("afp1H");

const $7e3c19665a3fd574$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rko12b0 _1dqonqa1 _189ee4h9 _1h6d1j28 _bfhk1j28 _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1v1w",
    lozengeDropdownContainer: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $7e3c19665a3fd574$var$textStyles = null;
const $7e3c19665a3fd574$var$triggerLozengeStyles = null;
const $7e3c19665a3fd574$var$triggerButtonStyles = null;
const $7e3c19665a3fd574$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, maxWidth: maxWidth, testId: testId, text: text, triggerRef: triggerRef, trailingMetric: trailingMetric, ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [isPressing, setIsPressing] = (0, $42omo.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $42omo.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $42omo.useState)(undefined);
    const onMouseOrKeyDown = (0, $42omo.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $42omo.useCallback)(()=>setIsPressing(false), []);
    (0, $42omo.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #8FB8F6)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else if (isOpen) {
            setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FE)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen
    ]);
    const lozenge = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: (0, $1bHXt.cx)($7e3c19665a3fd574$var$styles.lozengeContainer, (isOpen || isPressing) && $7e3c19665a3fd574$var$styles.lozengeContainerSelected),
            as: "span"
        }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: appearance,
            isBold: true,
            maxWidth: maxWidth,
            style: {
                backgroundColor: lozengeBackgroundColor,
                color: lozengeForegroundColor
            }
        }, /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                "_4cvr1h6o _1e0c1txw"
            ])
        }, /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
            ])
        }, text), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: $7e3c19665a3fd574$var$styles.chevronDown
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            color: "currentColor",
            label: "options",
            size: "small",
            "aria-hidden": true
        })))));
    }, [
        appearance,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor,
        maxWidth
    ]);
    return (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $7e3c19665a3fd574$var$styles.lozengeDropdownContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $9E7O8.default), {
        ...props,
        appearance: appearance,
        trailingMetric: trailingMetric,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        maxWidth: maxWidth,
        testId: testId,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $afp1H.messages).change_status, {
            status: text
        })
    }, text)) : /*#__PURE__*/ $42omo.createElement("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        style: {
            maxWidth: maxWidth
        },
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $afp1H.messages).change_status, {
            status: text
        }),
        className: (0, $gMc0m.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1dm9 _1h6d1j28 _bfhk1j28 _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas1qi0 _19h61qi0 _1d391qi0 _1ejj1y54 _1u6l1y54 _6ssh1y54"
        ])
    }, lozenge);
};
var $7e3c19665a3fd574$export$2e2bcd8739ae039 = $7e3c19665a3fd574$var$LozengeActionTrigger;
module.exports["default"] = $7e3c19665a3fd574$export$2e2bcd8739ae039;

});

parcelRegister("k5ktp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dAYOx = parcelRequire("dAYOx");


var $5nBzc = parcelRequire("5nBzc");

const $c9439470310c10a2$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $42omo.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        onFocus: handleMouseEnter,
        onMouseEnter: handleMouseEnter,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: true
    }, text)));
};
var $c9439470310c10a2$export$2e2bcd8739ae039 = $c9439470310c10a2$var$LozengeActionItem;
module.exports["default"] = $c9439470310c10a2$export$2e2bcd8739ae039;

});


$parcel$global.rlb("5ksq8")
//# sourceMappingURL=FullPageEditorComponent.f05d1e2e.js.map
